export class BaseEntity {
    static { this.entityName = 'BaseEntity'; }
}
export class DocumentHeader extends BaseEntity {
    static { this.entityName = 'DocumentHeader'; }
}
export class DocumentLine extends BaseEntity {
    static { this.entityName = 'DocumentLine'; }
}
export class BankAccount extends BaseEntity {
    static { this.entityName = 'BankAccount'; }
}
export class Identity {
    static { this.entityName = 'Identity'; }
}
export class ScheduledTask {
    static { this.entityName = 'ScheduledTask'; }
}
export class IdentityRole {
    static { this.entityName = 'IdentityRole'; }
}
export class PricelistRule extends BaseEntity {
    static { this.entityName = 'PricelistRule'; }
}
export class Party extends BaseEntity {
    static { this.entityName = 'Party'; }
}
export class Pricelist extends BaseEntity {
    static { this.entityName = 'Pricelist'; }
}
export class PricelistItem extends BaseEntity {
    static { this.entityName = 'PricelistItem'; }
}
export class SupplierStockItem extends BaseEntity {
    static { this.entityName = 'SupplierStockItem'; }
}
export class InboundDeliveryOrder extends BaseEntity {
    static { this.entityName = 'InboundDeliveryOrder'; }
}
export class Carrier extends BaseEntity {
    static { this.entityName = 'Carrier'; }
}
export class Brand extends BaseEntity {
    static { this.entityName = 'Brand'; }
}
export class Invoice extends BaseEntity {
    static { this.entityName = 'Invoice'; }
}
export class InvoiceLine extends DocumentLine {
    static { this.entityName = 'InvoiceLine'; }
}
export class InvoiceTaxLine extends BaseEntity {
    static { this.entityName = 'InvoiceTaxLine'; }
}
export class InboundDeliveryOrderLine extends BaseEntity {
    static { this.entityName = 'InboundDeliveryOrderLine'; }
}
export class OutboundDeliveryOrder extends BaseEntity {
    static { this.entityName = 'OutboundDeliveryOrder'; }
}
export class OutboundDeliveryOrderLine extends BaseEntity {
    static { this.entityName = 'OutboundDeliveryOrderLine'; }
}
export class KeyValueStore extends BaseEntity {
    static { this.entityName = 'KeyValueStore'; }
}
export class OutboundQueue extends BaseEntity {
    static { this.entityName = 'OutboundQueue'; }
}
export class SaleOrderLine extends BaseEntity {
    static { this.entityName = 'SaleOrderLine'; }
}
export class SaleOrder extends DocumentHeader {
    static { this.entityName = 'SaleOrder'; }
}
export class HandlingUnitType extends BaseEntity {
    static { this.entityName = 'HandlingUnitType'; }
}
export class HandlingUnit extends BaseEntity {
    static { this.entityName = 'HandlingUnit'; }
}
export class ItemCodeType extends BaseEntity {
    static { this.entityName = 'ItemCodeType'; }
}
export class ItemCode extends BaseEntity {
    static { this.entityName = 'ItemCode'; }
}
export class Item extends BaseEntity {
    static { this.entityName = 'Item'; }
}
export class ItemParameters {
    static { this.entityName = 'ItemParameters'; }
}
export class ItemParametersTire {
    static { this.entityName = 'ItemParametersTire'; }
}
export class OutboundRule extends BaseEntity {
    static { this.entityName = 'OutboundRule'; }
}
export class StockItemLocation extends BaseEntity {
    static { this.entityName = 'StockItemLocation'; }
}
export class StockItem extends BaseEntity {
    static { this.entityName = 'StockItem'; }
}
export class NestUser extends BaseEntity {
    static { this.entityName = 'NestUser'; }
}
export class StorageLocation extends BaseEntity {
    static { this.entityName = 'StorageLocation'; }
}
export class Activity extends BaseEntity {
    static { this.entityName = 'Activity'; }
}
export class NumericSequence extends BaseEntity {
    static { this.entityName = 'NumericSequence'; }
}
export class StockItemMovement extends BaseEntity {
    static { this.entityName = 'StockItemMovement'; }
}
export class ItemMovement extends BaseEntity {
    static { this.entityName = 'ItemMovement'; }
}
export class OutboundDelivery extends BaseEntity {
    static { this.entityName = 'OutboundDelivery'; }
}
export class OutboundDeliveryLine extends BaseEntity {
    static { this.entityName = 'OutboundDeliveryLine'; }
}
export class InboundDelivery extends BaseEntity {
    static { this.entityName = 'InboundDelivery'; }
}
export class InboundDeliveryLine extends BaseEntity {
    static { this.entityName = 'InboundDeliveryLine'; }
}
export class CustomPrintTemplate extends BaseEntity {
    static { this.entityName = 'CustomPrintTemplate'; }
}
export class WarehouseMoveItem extends BaseEntity {
    static { this.entityName = 'WarehouseMoveItem'; }
}
export class WarehouseMove extends BaseEntity {
    static { this.entityName = 'WarehouseMove'; }
}
export class Payment extends BaseEntity {
    static { this.entityName = 'Payment'; }
}
export class HandlingUnitMovement extends BaseEntity {
    static { this.entityName = 'HandlingUnitMovement'; }
}
export class EdiInboundOrder extends BaseEntity {
    static { this.entityName = 'EdiInboundOrder'; }
}
export class EdiInboundOrderEvent extends BaseEntity {
    static { this.entityName = 'EdiInboundOrderEvent'; }
}
export class EdiInboundBuffer extends BaseEntity {
    static { this.entityName = 'EdiInboundBuffer'; }
}
export class ParcelDeliveryDpdCountry {
    static { this.entityName = 'ParcelDeliveryDpdCountry'; }
}
export class ParcelDeliveryDpdRoute {
    static { this.entityName = 'ParcelDeliveryDpdRoute'; }
}
export class DeliveryFeeCalculator extends BaseEntity {
    static { this.entityName = 'DeliveryFeeCalculator'; }
}
export class DeliveryFeeCalculatorItem extends BaseEntity {
    static { this.entityName = 'DeliveryFeeCalculatorItem'; }
}
export class ExchangeRate extends BaseEntity {
    static { this.entityName = 'ExchangeRate'; }
}
export class DocumentSerie extends BaseEntity {
    static { this.entityName = 'DocumentSerie'; }
}
export class Warehouse extends BaseEntity {
    static { this.entityName = 'Warehouse'; }
}
export class PackageUnit extends BaseEntity {
    static { this.entityName = 'PackageUnit'; }
}
export class PackageUnitEvent extends BaseEntity {
    static { this.entityName = 'PackageUnitEvent'; }
}
export class PackageType extends BaseEntity {
    static { this.entityName = 'PackageType'; }
}
export class PackageSimulation extends BaseEntity {
    static { this.entityName = 'PackageSimulation'; }
}
export class Printer extends BaseEntity {
    static { this.entityName = 'Printer'; }
}
export class StockItemReservation extends BaseEntity {
    static { this.entityName = 'StockItemReservation'; }
}
export class ApplicationParameter extends BaseEntity {
    static { this.entityName = 'ApplicationParameter'; }
}
export class DeliveryItem extends BaseEntity {
    static { this.entityName = 'DeliveryItem'; }
}
export class ShipmentRoute extends BaseEntity {
    static { this.entityName = 'ShipmentRoute'; }
}
export class ShipmentRouteType extends BaseEntity {
    static { this.entityName = 'ShipmentRouteType'; }
}
export class ShipmentVehicle extends BaseEntity {
    static { this.entityName = 'ShipmentVehicle'; }
}
export class ShipmentStop extends BaseEntity {
    static { this.entityName = 'ShipmentStop'; }
}
export class ShipmentStopAssignment extends BaseEntity {
    static { this.entityName = 'ShipmentStopAssignment'; }
}
export class NestSentMail {
    static { this.entityName = 'NestSentMail'; }
}
export class OrganizationPricelist extends BaseEntity {
    static { this.entityName = 'OrganizationPricelist'; }
}
export class OrganizationPricelistItem extends BaseEntity {
    static { this.entityName = 'OrganizationPricelistItem'; }
}
export class StockTake extends BaseEntity {
    static { this.entityName = 'StockTake'; }
}
export class StockTakeItem extends BaseEntity {
    static { this.entityName = 'StockTakeItem'; }
}
export class StorageInventory extends BaseEntity {
    static { this.entityName = 'StorageInventory'; }
}
export class ShipmentRouteRule extends BaseEntity {
    static { this.entityName = 'ShipmentRouteRule'; }
}
export class IdentityPreferences extends BaseEntity {
    static { this.entityName = 'IdentityPreferences'; }
}
export class PersonalizedList extends BaseEntity {
    static { this.entityName = 'PersonalizedList'; }
}
export class SupplierPricelist extends BaseEntity {
    static { this.entityName = 'SupplierPricelist'; }
}
export class SupplierPricelistItem extends BaseEntity {
    static { this.entityName = 'SupplierPricelistItem'; }
}
export class DocumentTemplate extends BaseEntity {
    static { this.entityName = 'DocumentTemplate'; }
}
export class SupplierStockImport extends BaseEntity {
    static { this.entityName = 'SupplierStockImport'; }
}
export class Machine extends BaseEntity {
    static { this.entityName = 'Machine'; }
}
export class PredefinedText extends BaseEntity {
    static { this.entityName = 'PredefinedText'; }
}
export class DeliveryTypeToPaymentType extends BaseEntity {
    static { this.entityName = 'DeliveryTypeToPaymentType'; }
}
export class Tax extends BaseEntity {
    static { this.entityName = 'Tax'; }
}
export class TaxItem extends BaseEntity {
    static { this.entityName = 'TaxItem'; }
}
export class EdiFtpAccount extends BaseEntity {
    static { this.entityName = 'EdiFtpAccount'; }
}
export class PriceType extends BaseEntity {
    static { this.entityName = 'PriceType'; }
}
export class FifoPriceSnapshot {
    static { this.entityName = 'FifoPriceSnapshot'; }
}
export class CarrierCommunicationItem {
    static { this.entityName = 'CarrierCommunicationItem'; }
}
export class DocumentType extends BaseEntity {
    static { this.entityName = 'DocumentType'; }
}
export class InboundDeliveryOrderDocumentType extends BaseEntity {
    static { this.entityName = 'InboundDeliveryOrderDocumentType'; }
}
export class OutboundDeliveryOrderDocumentType extends BaseEntity {
    static { this.entityName = 'OutboundDeliveryOrderDocumentType'; }
}
export class InboundDeliveryRequestDocumentType extends BaseEntity {
    static { this.entityName = 'InboundDeliveryRequestDocumentType'; }
}
export class OutboundDeliveryRequestDocumentType extends DocumentType {
    static { this.entityName = 'OutboundDeliveryRequestDocumentType'; }
}
export class OutboundDocumentType extends BaseEntity {
    static { this.entityName = 'OutboundDocumentType'; }
}
export class InboundDocumentType extends BaseEntity {
    static { this.entityName = 'InboundDocumentType'; }
}
export class IssuedInvoiceDocumentType extends DocumentType {
    static { this.entityName = 'IssuedInvoiceDocumentType'; }
}
export class ReceivedInvoiceDocumentType extends DocumentType {
    static { this.entityName = 'ReceivedInvoiceDocumentType'; }
}
export class InboundDocumentLine extends DocumentLine {
    static { this.entityName = 'InboundDocumentLine'; }
}
export class OutboundDocumentLine extends BaseEntity {
    static { this.entityName = 'OutboundDocumentLine'; }
}
export class SalesChannel extends BaseEntity {
    static { this.entityName = 'SalesChannel'; }
}
export class SalesChannelGroup extends BaseEntity {
    static { this.entityName = 'SalesChannelGroup'; }
}
export class OutboundDeliveryDocumentType extends DocumentType {
    static { this.entityName = 'OutboundDeliveryDocumentType'; }
}
export class InboundDeliveryDocumentType extends DocumentType {
    static { this.entityName = 'InboundDeliveryDocumentType'; }
}
export class ItemCollection extends BaseEntity {
    static { this.entityName = 'ItemCollection'; }
}
export class SaleOrderDocumentType extends BaseEntity {
    static { this.entityName = 'SaleOrderDocumentType'; }
}
export class PurchaseOrderDocumentType extends DocumentType {
    static { this.entityName = 'PurchaseOrderDocumentType'; }
}
export class InboundDocument extends BaseEntity {
    static { this.entityName = 'InboundDocument'; }
}
export class OutboundDocument extends BaseEntity {
    static { this.entityName = 'OutboundDocument'; }
}
export class InventoryItemDaily extends BaseEntity {
    static { this.entityName = 'InventoryItemDaily'; }
}
export class TemporaryFile extends BaseEntity {
    static { this.entityName = 'TemporaryFile'; }
}
export class NestJob {
    static { this.entityName = 'NestJob'; }
}
export class Notification extends BaseEntity {
    static { this.entityName = 'Notification'; }
}
export class BatchInvoiceRule extends BaseEntity {
    static { this.entityName = 'BatchInvoiceRule'; }
}
export class ItemCategory extends BaseEntity {
    static { this.entityName = 'ItemCategory'; }
}
export class ItemCategoryGroup extends BaseEntity {
    static { this.entityName = 'ItemCategoryGroup'; }
}
export class DeliveryPricelist extends BaseEntity {
    static { this.entityName = 'DeliveryPricelist'; }
}
export class DeliveryPricelistItem extends BaseEntity {
    static { this.entityName = 'DeliveryPricelistItem'; }
}
export class SynchronizationItem {
    static { this.entityName = 'SynchronizationItem'; }
}
export class PurchaseOrder extends BaseEntity {
    static { this.entityName = 'PurchaseOrder'; }
}
export class PurchaseOrderLine extends DocumentLine {
    static { this.entityName = 'PurchaseOrderLine'; }
}
export class PackingLineConfigurationDock extends BaseEntity {
    static { this.entityName = 'PackingLineConfigurationDock'; }
}
export class PartySalesmanAssign {
    static { this.entityName = 'PartySalesmanAssign'; }
}
export class PartyTag {
    static { this.entityName = 'PartyTag'; }
}
export class SaleOrderRule extends BaseEntity {
    static { this.entityName = 'SaleOrderRule'; }
}
export class TerminalConfiguration extends BaseEntity {
    static { this.entityName = 'TerminalConfiguration'; }
}
export class TerminalConfigurationView extends BaseEntity {
    static { this.entityName = 'TerminalConfigurationView'; }
}
export class ClearingPrescription extends BaseEntity {
    static { this.entityName = 'ClearingPrescription'; }
}
export class DocumentLineTemplate extends BaseEntity {
    static { this.entityName = 'DocumentLineTemplate'; }
}
export class ClearingPrescriptionItem extends BaseEntity {
    static { this.entityName = 'ClearingPrescriptionItem'; }
}
export class SepaOptions extends BaseEntity {
    static { this.entityName = 'SepaOptions'; }
}
export class SepaPayment extends BaseEntity {
    static { this.entityName = 'SepaPayment'; }
}
export class ApplicationRule extends BaseEntity {
    static { this.entityName = 'ApplicationRule'; }
}
export class InventoryItem extends BaseEntity {
    static { this.entityName = 'InventoryItem'; }
}
export class WarehouseDeliveryAreaItem extends BaseEntity {
    static { this.entityName = 'WarehouseDeliveryAreaItem'; }
}
export class ItemReporting {
    static { this.entityName = 'ItemReporting'; }
}
export class UserTrackingRecord {
    static { this.entityName = 'UserTrackingRecord'; }
}
export class IdentityTerminalState extends BaseEntity {
    static { this.entityName = 'IdentityTerminalState'; }
}
export class WarehouseProcessBatchItem extends BaseEntity {
    static { this.entityName = 'WarehouseProcessBatchItem'; }
}
export class WarehouseRelation extends BaseEntity {
    static { this.entityName = 'WarehouseRelation'; }
}
export class WarehouseRelationItem extends BaseEntity {
    static { this.entityName = 'WarehouseRelationItem'; }
}
export class CustomEntityView extends BaseEntity {
    static { this.entityName = 'CustomEntityView'; }
}
export class InboundQueue extends BaseEntity {
    static { this.entityName = 'InboundQueue'; }
}
export class WarehouseCarrier extends BaseEntity {
    static { this.entityName = 'WarehouseCarrier'; }
}
export class ItemCheapestDelivery extends BaseEntity {
    static { this.entityName = 'ItemCheapestDelivery'; }
}
export class ConsignmentNote extends BaseEntity {
    static { this.entityName = 'ConsignmentNote'; }
}
export class ConsignmentNoteLine extends BaseEntity {
    static { this.entityName = 'ConsignmentNoteLine'; }
}
export class SupplyChannel extends BaseEntity {
    static { this.entityName = 'SupplyChannel'; }
}
export class EltmaItem extends BaseEntity {
    static { this.entityName = 'EltmaItem'; }
}
export class EltmaItemRefund extends BaseEntity {
    static { this.entityName = 'EltmaItemRefund'; }
}
export class CpostLocation {
    static { this.entityName = 'CpostLocation'; }
}
export class NestJobSubscription {
    static { this.entityName = 'NestJobSubscription'; }
}
export class ShipmentArea extends BaseEntity {
    static { this.entityName = 'ShipmentArea'; }
}
export class ShipmentAreaZip extends BaseEntity {
    static { this.entityName = 'ShipmentAreaZip'; }
}
export class ShipmentRouteLink extends BaseEntity {
    static { this.entityName = 'ShipmentRouteLink'; }
}
export class ShipmentRouteLinkZip extends BaseEntity {
    static { this.entityName = 'ShipmentRouteLinkZip'; }
}
export class OutboundDocumentDeliveryDateRule extends BaseEntity {
    static { this.entityName = 'OutboundDocumentDeliveryDateRule'; }
}
export class AddressToGps extends BaseEntity {
    static { this.entityName = 'AddressToGps'; }
}
export class NumericSequenceItem extends BaseEntity {
    static { this.entityName = 'NumericSequenceItem'; }
}
export class BankAccountSnapshot {
    static { this.entityName = 'BankAccountSnapshot'; }
}
export class PriceAmount {
    static { this.entityName = 'PriceAmount'; }
}
export class PartySnapshot {
    static { this.entityName = 'PartySnapshot'; }
}
export class ShipmentVehicleShipmentTypeSetting extends BaseEntity {
    static { this.entityName = 'ShipmentVehicleShipmentTypeSetting'; }
}
export class Gps {
    static { this.entityName = 'Gps'; }
}
export class ShipmentVehicleTracking extends BaseEntity {
    static { this.entityName = 'ShipmentVehicleTracking'; }
}
export class DeliveryPlan extends BaseEntity {
    static { this.entityName = 'DeliveryPlan'; }
}
export class UpsInvoiceItem {
    static { this.entityName = 'UpsInvoiceItem'; }
}
export class Deposit extends BaseEntity {
    static { this.entityName = 'Deposit'; }
}
export class DepositItem extends BaseEntity {
    static { this.entityName = 'DepositItem'; }
}
export class DeliveryReturn extends BaseEntity {
    static { this.entityName = 'DeliveryReturn'; }
}
export class Return extends BaseEntity {
    static { this.entityName = 'Return'; }
}
export class ReturnLine extends BaseEntity {
    static { this.entityName = 'ReturnLine'; }
}
export class CartLine {
    static { this.entityName = 'CartLine'; }
}
export class EndCustomer {
    static { this.entityName = 'EndCustomer'; }
}
export class EndCustomerVehicle {
    static { this.entityName = 'EndCustomerVehicle'; }
}
export class EndCustomerReservation {
    static { this.entityName = 'EndCustomerReservation'; }
}
export class PartyIdentity {
    static { this.entityName = 'PartyIdentity'; }
}
export class PartyDepositSettings extends BaseEntity {
    static { this.entityName = 'PartyDepositSettings'; }
}
export class InboundShipment extends BaseEntity {
    static { this.entityName = 'InboundShipment'; }
}
export class InboundShipmentLine extends BaseEntity {
    static { this.entityName = 'InboundShipmentLine'; }
}
export class InboundShipmentType extends BaseEntity {
    static { this.entityName = 'InboundShipmentType'; }
}
export class TireosInvoiceExport extends BaseEntity {
    static { this.entityName = 'TireosInvoiceExport'; }
}
export class TireosPreferences extends BaseEntity {
    static { this.entityName = 'TireosPreferences'; }
}
export class OutboundDocumentPackageSimulation extends BaseEntity {
    static { this.entityName = 'OutboundDocumentPackageSimulation'; }
}
export class OutboundDocumentPackageSimulationPackageType {
    static { this.entityName = 'OutboundDocumentPackageSimulationPackageType'; }
}
export class Task {
    static { this.entityName = 'Task'; }
}
export class TaskRecord {
    static { this.entityName = 'TaskRecord'; }
}
export class PricemachineWorkspace extends BaseEntity {
    static { this.entityName = 'PricemachineWorkspace'; }
}
export class PricemachineItemPricing extends BaseEntity {
    static { this.entityName = 'PricemachineItemPricing'; }
}
export class PricemachineDataSource extends BaseEntity {
    static { this.entityName = 'PricemachineDataSource'; }
}
export class PricemachineDataImportRun extends BaseEntity {
    static { this.entityName = 'PricemachineDataImportRun'; }
}
export class PricemachineDataTyre24Price extends BaseEntity {
    static { this.entityName = 'PricemachineDataTyre24Price'; }
}
export class PricemachineDataNestSales extends BaseEntity {
    static { this.entityName = 'PricemachineDataNestSales'; }
}
export class PricemachineDataPneub2bStock extends BaseEntity {
    static { this.entityName = 'PricemachineDataPneub2bStock'; }
}
export class PricemachineConstant extends BaseEntity {
    static { this.entityName = 'PricemachineConstant'; }
}
export class PricemachineCalculationNode extends BaseEntity {
    static { this.entityName = 'PricemachineCalculationNode'; }
}
export class PricemachineCalculationEdge extends BaseEntity {
    static { this.entityName = 'PricemachineCalculationEdge'; }
}
export class PricemachinePipeline extends BaseEntity {
    static { this.entityName = 'PricemachinePipeline'; }
}
export class PricemachinePipelineNode extends BaseEntity {
    static { this.entityName = 'PricemachinePipelineNode'; }
}
export class PricemachinePipelineEdge extends BaseEntity {
    static { this.entityName = 'PricemachinePipelineEdge'; }
}
export class PricemachinePricelist extends BaseEntity {
    static { this.entityName = 'PricemachinePricelist'; }
}
export class PricemachineRepricingProposal extends BaseEntity {
    static { this.entityName = 'PricemachineRepricingProposal'; }
}
export class PricemachineCalculationLog extends BaseEntity {
    static { this.entityName = 'PricemachineCalculationLog'; }
}
export class PricemachineConstantVersion extends BaseEntity {
    static { this.entityName = 'PricemachineConstantVersion'; }
}
export class PricemachineCalculationTreeVersion extends BaseEntity {
    static { this.entityName = 'PricemachineCalculationTreeVersion'; }
}
export class PricemachinePipelineVersion extends BaseEntity {
    static { this.entityName = 'PricemachinePipelineVersion'; }
}
export class PricemachineWorkspacePreferences extends BaseEntity {
    static { this.entityName = 'PricemachineWorkspacePreferences'; }
}
import { z } from 'zod';
export const DocumentHeaderSchemaStateEnum = z.enum(['Created', 'InProgress', 'Completed', 'Canceled', 'Archived']);
export const DocumentHeaderSchemaConfirmStateEnum = z.enum(['None', 'Unconfirmed', 'Confirmed']);
export const DocumentHeaderSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const DocumentHeaderSchemaTaxRegionEnum = z.enum(['Local', 'EU', 'World']);
export const DocumentHeaderSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const DocumentHeaderSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const DocumentLineSchemaUnitEnum = z.enum(['Piece', 'Kilogram']);
export const DocumentLineSchemaConfirmStateEnum = z.enum(['None', 'Unconfirmed', 'Confirmed']);
export const DocumentLineSchemaLineItemTypeEnum = z.enum(['Item', 'Text']);
export const BankAccountSchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const BankAccountSchemaTypeEnum = z.enum(['Billing', 'CashOnDelivery']);
export const IdentitySchemaLocaleEnum = z.enum(['CZ', 'EN', 'SK', 'DE', 'IT', 'FR', 'PL']);
export const PricelistRuleSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PricelistRuleSchemaSurchargeTypeEnum = z.enum(['Fix', 'Percent']);
export const PartySchemaLawTypeEnum = z.enum(['Company', 'Individual', 'Private']);
export const PartySchemaTaxModeEnum = z.enum(['Payer', 'NonPayer']);
export const PartySchemaLanguageEnum = z.enum(['CZ', 'EN', 'SK', 'DE', 'IT', 'FR', 'PL']);
export const PartySchemaTaxRegionEnum = z.enum(['Local', 'EU', 'World']);
export const PartySchemaDefaultPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const PartySchemaInvoiceDeliveryMethodTypeEnum = z.enum(['Print', 'Email']);
export const PartySchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const PartySchemaApprovedStateEnum = z.enum(['Pending', 'Approved', 'Rejected', 'Blocked']);
export const PartySchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PricelistSchemaTypeEnum = z.enum(['Default', 'Calculated']);
export const PricelistSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PricelistSchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const PricelistItemSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const SupplierStockItemSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const InboundDeliveryOrderSchemaStateEnum = z.enum(['Created', 'InProgress', 'Completed', 'Canceled', 'Archived']);
export const CarrierSchemaHandlerEnum = z.enum(['DPD', 'CPOST', 'GLS', 'UPS']);
export const InvoiceSchemaTaxRegionEnum = z.enum(['Local', 'EU', 'World']);
export const InvoiceSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const InvoiceSchemaStateEnum = z.enum(['Created', 'InProgress', 'Completed', 'Canceled', 'Archived']);
export const InvoiceSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const InvoiceSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const InvoiceSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const InvoiceSchemaPaymentStateEnum = z.enum(['Unpaid', 'PartiallyPaid', 'Paid']);
export const InboundDeliveryOrderLineSchemaUnitEnum = z.enum(['Piece', 'Kilogram']);
export const InboundDeliveryOrderLineSchemaConfirmStateEnum = z.enum(['None', 'Unconfirmed', 'Confirmed']);
export const InboundDeliveryOrderLineSchemaLineItemTypeEnum = z.enum(['Item', 'Text']);
export const OutboundDeliveryOrderSchemaStateEnum = z.enum(['Created', 'ToProcess', 'InProgress', 'Dispatched', 'Canceled']);
export const OutboundDeliveryOrderSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const OutboundDeliveryOrderSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const OutboundDeliveryOrderSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const OutboundDeliveryOrderSchemaShipmentStateEnum = z.enum(['Unplanned', 'Planned', 'Created', 'Loaded', 'InDelivery', 'Unloaded', 'Completed', 'Skipped', 'Canceled', 'CanceledOnCheck']);
export const OutboundQueueSchemaTypeEnum = z.enum(['Terminal', 'PackingLine']);
export const SaleOrderLineSchemaUnitEnum = z.enum(['Piece', 'Kilogram']);
export const SaleOrderLineSchemaConfirmStateEnum = z.enum(['None', 'Unconfirmed', 'Confirmed']);
export const SaleOrderLineSchemaLineItemTypeEnum = z.enum(['Item', 'Text']);
export const SaleOrderSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const SaleOrderSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const SaleOrderSchemaValidationStateEnum = z.enum(['Valid', 'Invalid']);
export const SaleOrderSchemaOutboundStateEnum = z.enum(['None', 'Partially', 'All']);
export const SaleOrderSchemaReservationStateEnum = z.enum(['None', 'Partially', 'Requested', 'All']);
export const SaleOrderSchemaFulfilmentStateEnum = z.enum(['Created', 'Partially', 'Dispatched', 'Complete']);
export const SaleOrderSchemaPaymentStateEnum = z.enum(['Unpaid', 'PartiallyPaid', 'Paid']);
export const SaleOrderSchemaAutomationStateEnum = z.enum(['None', 'Process', 'Failed', 'Completed']);
export const HandlingUnitTypeSchemaFixedTypeEnum = z.enum(['Pallete', 'Box']);
export const HandlingUnitSchemaStateEnum = z.enum(['Free', 'Loaded']);
export const HandlingUnitSchemaExternalLocationEnum = z.enum(['Warehouse', 'DestinationPoint', 'InDelivery']);
export const ItemSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const ItemSchemaTypeEnum = z.enum(['Catalog', 'Root', 'Fee', 'Rounding']);
export const ItemParametersTireSchemaTireSeasonEnum = z.enum(['Summer', 'Winter', 'AllSeason']);
export const StockItemLocationSchemaOriginCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const StorageLocationSchemaTypeEnum = z.enum(['Default', 'User', 'Inbound', 'Outbound', 'Delivery']);
export const NumericSequenceSchemaLifespanEnum = z.enum(['Permanent', 'Yearly']);
export const NumericSequenceSchemaTypeEnum = z.enum(['InboundInventoryMove', 'OutboundInventoryMove', 'DocumentSerie', 'Deposit', 'FinancialDocumentSerie', 'Order']);
export const StockItemMovementSchemaSkuDirectionTypeEnum = z.enum(['Inbound', 'Outbound', 'Move']);
export const StockItemMovementSchemaOriginCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const ItemMovementSchemaDirectionTypeEnum = z.enum(['Inbound', 'Outbound']);
export const WarehouseMoveItemSchemaStateEnum = z.enum(['Created', 'Loaded', 'Completed']);
export const WarehouseMoveSchemaTypeEnum = z.enum(['Palette', 'Sku']);
export const PaymentSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PaymentSchemaTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const EdiInboundOrderSchemaStateEnum = z.enum(['Received', 'Accepted', 'Rejected', 'InternalError', 'AcceptanceSent', 'RejectionSent', 'TrackingSent', 'InvoiceSent', 'EmailSent', 'Finished']);
export const EdiInboundOrderEventSchemaTypeEnum = z.enum(['Received', 'Accepted', 'Rejected', 'InternalError', 'AcceptanceSent', 'RejectionSent', 'TrackingSent', 'InvoiceSent', 'EmailSent', 'Finished']);
export const EdiInboundBufferSchemaStateEnum = z.enum(['Received', 'Processing', 'Processed', 'Duplicate', 'NoOrders', 'Invalid']);
export const ExchangeRateSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const DocumentSerieSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const PackageUnitSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const PackageUnitSchemaCashOnDeliveryCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PackageUnitSchemaStateEnum = z.enum(['Draft', 'CarrierRequested', 'CarrierConfirmed', 'Confirmed', 'Exported', 'Canceled']);
export const PackageUnitSchemaDeliveryStatusEnum = z.enum(['Created', 'Accepted', 'InTransit', 'PickedByDriver', 'Delivered', 'OutForDelivery', 'DeliveryAttempted', 'ReturnedToSender', 'Exception', 'Cancelled']);
export const PackageUnitEventSchemaStatusEnum = z.enum(['Created', 'Accepted', 'InTransit', 'PickedByDriver', 'OutForDelivery', 'Delivered', 'DeliveryAttempted', 'ReturnedToSender', 'Exception', 'Cancelled']);
export const PackageTypeSchemaHandlerEnum = z.enum(['DPD', 'CPOST', 'GLS', 'UPS']);
export const PackageSimulationSchemaStatusEnum = z.enum(['Pending', 'Running', 'Completed', 'Failed']);
export const PrinterSchemaTypeEnum = z.enum(['Default', 'Thermal']);
export const ShipmentRouteSchemaStateEnum = z.enum(['Draft', 'Created', 'InProgress', 'Completed', 'Canceled']);
export const ShipmentStopSchemaTypeEnum = z.enum(['Start', 'Stop', 'End', 'Pickup', 'Delivery']);
export const ShipmentStopSchemaStateEnum = z.enum(['Created', 'Arrived', 'Completed', 'Skipped', 'Canceled']);
export const ShipmentStopAssignmentSchemaActionEnum = z.enum(['Load', 'Unload']);
export const StockTakeSchemaStateEnum = z.enum(['Created', 'InProgress', 'Completed', 'Canceled']);
export const StockTakeItemSchemaStateEnum = z.enum(['Created', 'Invalid', 'InvalidCompleted', 'Completed', 'Skipped']);
export const SupplierPricelistSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const SupplierStockImportSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const DeliveryTypeToPaymentTypeSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const DeliveryTypeToPaymentTypeSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const TaxItemSchemaTaxRegionEnum = z.enum(['Local', 'EU', 'World']);
export const DocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const DocumentTypeSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const DocumentTypeSchemaExchanRateTypeEnum = z.enum(['Daily', 'Fixed', 'Fixed2']);
export const DocumentTypeSchemaDefaultPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const OutboundDeliveryOrderDocumentTypeSchemaPackingTypeEnum = z.enum(['ManualHandlingUnit', 'PackingLine', 'ManualPackageUnit']);
export const OutboundDeliveryOrderDocumentTypeSchemaCheckingTypeEnum = z.enum(['PackingLine', 'Manual']);
export const OutboundDeliveryOrderDocumentTypeSchemaShipmentTypeEnum = z.enum(['Shipment', 'Carrier']);
export const OutboundDeliveryRequestDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const OutboundDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const OutboundDocumentTypeSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const OutboundDocumentTypeSchemaExchanRateTypeEnum = z.enum(['Daily', 'Fixed', 'Fixed2']);
export const OutboundDocumentTypeSchemaDefaultPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const OutboundDocumentTypeSchemaConfirmationStrategyEnum = z.enum(['None', 'ConfirmRequired']);
export const OutboundDocumentTypeSchemaCompletationStrategyEnum = z.enum(['Invoice', 'Valuation', 'Confirm']);
export const InboundDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const InboundDocumentTypeSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const InboundDocumentTypeSchemaExchanRateTypeEnum = z.enum(['Daily', 'Fixed', 'Fixed2']);
export const InboundDocumentTypeSchemaDefaultPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const IssuedInvoiceDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const ReceivedInvoiceDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const OutboundDocumentLineSchemaLineItemTypeEnum = z.enum(['Item', 'Text']);
export const SalesChannelSchemaCarrierSelectionStrategyEnum = z.enum(['FromSeller', 'Cheapest', 'Strict']);
export const SalesChannelSchemaDefaultApprovedStateEnum = z.enum(['Pending', 'Approved', 'Rejected', 'Blocked']);
export const SalesChannelSchemaDefaultLanguageEnum = z.enum(['CZ', 'EN', 'SK', 'DE', 'IT', 'FR', 'PL']);
export const SalesChannelSchemaExchangeRateTypeEnum = z.enum(['Daily', 'Fixed', 'Fixed2']);
export const SalesChannelSchemaEdiHandlerEnum = z.enum(['ZR07', 'TtgXml4', 'TtgXml5', 'TtgXml6', 'Tyre100', 'Tyre24', 'Tyre24Mediator', 'GoodyearWsi', 'Euromaster', 'PneuB2B', 'PneuB2Bv2']);
export const SalesChannelSchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const OutboundDeliveryDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const InboundDeliveryDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const SaleOrderDocumentTypeSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const SaleOrderDocumentTypeSchemaExchanRateTypeEnum = z.enum(['Daily', 'Fixed', 'Fixed2']);
export const SaleOrderDocumentTypeSchemaDefaultPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const SaleOrderDocumentTypeSchemaAgendaTypeEnum = z.enum(['SaleOrder', 'PurchaseOrder', 'ReceivedInvoice', 'IssuedInvoice', 'OutboundDocument', 'InboundDocument', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'OutboundDelivery', 'InboundDelivery', 'InboundDeliveryOrder', 'OutboundDeliveryOrder', 'DispatchAdvice', 'OutboundDispatchAdvice']);
export const PurchaseOrderDocumentTypeSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const InboundDocumentSchemaStateEnum = z.enum(['Created', 'SentToWms', 'CompletedInWms', 'CanceledInWms', 'Received', 'Completed', 'Canceled']);
export const InboundDocumentSchemaTaxRegionEnum = z.enum(['Local', 'EU', 'World']);
export const InboundDocumentSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const InboundDocumentSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const InboundDocumentSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const OutboundDocumentSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const OutboundDocumentSchemaTaxRegionEnum = z.enum(['Local', 'EU', 'World']);
export const OutboundDocumentSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const OutboundDocumentSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const OutboundDocumentSchemaStateEnum = z.enum(['Created', 'SentToWms', 'CompletedInWms', 'CanceledInWms', 'Dispatched', 'Canceled', 'Completed']);
export const OutboundDocumentSchemaShipmentStateEnum = z.enum(['Unplanned', 'Planned', 'Created', 'Loaded', 'InDelivery', 'Unloaded', 'Completed', 'Skipped', 'Canceled', 'CanceledOnCheck']);
export const OutboundDocumentSchemaLastStateBeforeCancelEnum = z.enum(['Created', 'SentToWms', 'CompletedInWms', 'CanceledInWms', 'Dispatched', 'Canceled', 'Completed']);
export const NestJobSchemaStateEnum = z.enum(['Created', 'Active', 'Completed', 'Failed', 'Timeouted', 'Retry', 'Canceled']);
export const DeliveryPricelistItemSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const DeliveryPricelistItemSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const DeliveryPricelistItemSchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const DeliveryPricelistItemSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const SynchronizationItemSchemaStateEnum = z.enum(['Pending', 'OK', 'Failed', 'Skipped']);
export const PurchaseOrderSchemaStateEnum = z.enum(['Created', 'InProgress', 'Completed', 'Canceled', 'Archived']);
export const PurchaseOrderSchemaTaxRegionEnum = z.enum(['Local', 'EU', 'World']);
export const PurchaseOrderSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PurchaseOrderSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const PurchaseOrderSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const PackingLineConfigurationDockSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const PackingLineConfigurationDockSchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const TerminalConfigurationSchemaMenuItemsEnum = z.enum(['Info', 'Inbound', 'Outbound', 'Move', 'Packing', 'StockTake', 'HandlingUnitMove']);
export const TerminalConfigurationViewSchemaCodeEnum = z.enum(['StockItem:dltrm.info.stockItem', 'StockItemStorageLocation:grid:trm.info.stockItem.locations', 'HandlingUnit:dltrm.info.handlingUnit', 'StockItemStorageLocation:grid:trm.info.handlingUnit.stockItems', 'StorageLocation:dltrm.info.storageLocation', 'StockItemStorageLocation:grid:trm.info.storageLocation.stockItems', 'OutboundDeliveryOrder:dltrm.outbound.info', 'OutboundDeliveryOrderLine:grid:trm.outbound.items', 'InboundDeliveryOrder:dltrm.inbound.info', 'InboundDeliveryOrderLine:grid:trm.inbound.items', 'OutboundDeliveryOrderLine:grid:trm.outbound.process.unloaded', 'OutboundDeliveryOrderLine:grid:trm.outbound.process.loaded', 'OutboundDeliveryOrderLine:dltrm.outbound.process.task.info', 'InboundDeliveryOrderLine:grid:trm.inbound.pickups', 'WarehouseTaskRetrieve:dltrm.inbound.process.task.info', 'InboundDeliveryOrderLine:grid:trm.inbound.overview']);
export const DocumentLineTemplateSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const ClearingPrescriptionItemSchemaAgendaTypeEnum = z.enum(['IssuedInvoice', 'ReceivedInvoice', 'OutboundDelivery', 'InboundDelivery', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'OutboundDeliveryRequest', 'InboundDeliveryRequest', 'SaleOrder', 'PurchaseOrder', 'DispatchAdvice', 'OutboundDispatchAdvice', 'InboundDispatchAdvice', 'InboundDocument']);
export const SepaOptionsSchemaPaymentTypeEnum = z.enum(['Cash', 'BankTransfer', 'Card', 'SEPA', 'CashOnDelivery', 'SEPAB2B', 'CashOnB2B']);
export const SepaOptionsSchemaLocalInstrumentEnum = z.enum(['CORE', 'B2B']);
export const SepaPaymentSchemaSequenceTypeEnum = z.enum(['FRST', 'RCUR', 'FNAL', 'OOFF']);
export const SepaPaymentSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const ApplicationRuleSchemaTypeEnum = z.enum(['BeforeCreate']);
export const IdentityTerminalStateSchemaHasActiveInWarehouseMoveEnum = z.enum(['Palette', 'Sku']);
export const WarehouseRelationSchemaTypeEnum = z.enum(['MoveStockItem', 'MoveHandingUnit', 'OutboundDeliveryOrder', 'InboundDeliveryOrder', 'WavelessOutbound', 'ShipmentRouteLoading']);
export const WarehouseRelationItemSchemaOriginCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const ItemCheapestDeliverySchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const PartySnapshotSchemaCountryEnum = z.enum(['EU', 'AD', 'AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'NE', 'BR', 'ZA', 'YU', 'US', 'TR', 'SH', 'JP', 'MX', 'IN', 'FI', 'ER', 'FO', 'ID', 'HT', 'PT', 'CM', 'CA', 'NL', 'PL', 'RO', 'SK', 'CN', 'KR', 'BG', 'TH', 'RS', 'SI']);
export const PartySnapshotSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const DepositSchemaStateEnum = z.enum(['Created', 'InboundRequest', 'Store', 'OutboundRequest', 'Outbound', 'Cancelled', 'Completed']);
export const DepositSchemaSeasonEnum = z.enum(['Summer', 'Winter', 'All']);
export const EndCustomerReservationSchemaReservationTypeEnum = z.enum(['tireChange']);
export const EndCustomerReservationSchemaStatusEnum = z.enum(['pending', 'confirmed', 'cancelled']);
export const InboundShipmentSchemaStateEnum = z.enum(['Created', 'Draft', 'Planned', 'Completed', 'Canceled']);
export const InboundShipmentSchemaDeliveryTypeEnum = z.enum(['Personal', 'Delivery', 'Carrier']);
export const OutboundDocumentPackageSimulationSchemaStatusEnum = z.enum(['Packed', 'Failed']);
export const TaskSchemaPriorityEnum = z.enum(['Low', 'Normal', 'High', 'Urgent']);
export const TaskSchemaStatusEnum = z.enum(['Open', 'InProgress', 'Blocked', 'Done', 'Cancelled']);
export const TaskRecordSchemaTypeEnum = z.enum(['Comment', 'AssignmentChanged', 'StatusChanged', 'Closed', 'Reopened', 'DeadlineChanged', 'PriorityChanged']);
export const PricemachineItemPricingSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PricemachineDataImportRunSchemaStatusEnum = z.enum(['running', 'completed', 'failed', 'cancelled']);
export const PricemachineConstantSchemaScopeEnum = z.enum(['workspace', 'global']);
export const PricemachineConstantSchemaTypeEnum = z.enum(['system', 'static', 'relative', 'computed']);
export const PricemachineConstantSchemaValueTypeEnum = z.enum(['number', 'text', 'date', 'boolean', 'enum']);
export const PricemachineCalculationNodeSchemaNodeTypeEnum = z.enum(['filter', 'price-modifier', 'computed-variable', 'warning', 'pricelist', 'pipeline']);
export const PricemachinePipelineNodeSchemaNodeTypeEnum = z.enum(['input', 'output', 'filter', 'price-modifier', 'computed-variable', 'warning']);
export const PricemachinePricelistSchemaCurrencyEnum = z.enum(['CZK', 'EUR', 'USD']);
export const PricemachinePricelistSchemaOutputFormatEnum = z.enum(['csv', 'xlsx', 'json', 'xml']);
export const PricemachineRepricingProposalSchemaStatusEnum = z.enum(['pending', 'approved', 'rejected']);
export const PricemachineCalculationLogSchemaLevelEnum = z.enum(['debug', 'info', 'warning', 'error']);
export const BaseEntitySchema = z.object({
    id: z.number(),
    createdAt: z.coerce.date(),
    createdBy: z.object({ id: z.number() }),
    updatedAt: z.coerce.date(),
    updatedBy: z.object({ id: z.number() }),
    version: z.number().nullish(),
    deletedAt: z.coerce.date().nullish()
});
export const DocumentHeaderSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    documentNumber: z.string(),
    documentKindMask: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    buyerOrderNumber: z.string().nullish(),
    foreignInvoiceNumber: z.string().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    issuedDate: z.coerce.date().nullish(),
    archived: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    requestDate: z.coerce.date().nullish(),
    dispatchedAt: z.coerce.date().nullish(),
    priceRounding: z.number().nullish(),
    state: DocumentHeaderSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    confirmState: DocumentHeaderSchemaConfirmStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Confirmed' : v)),
    contractor: z.object({ id: z.number() }),
    contractorSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    buyer: z.object({ id: z.number() }),
    buyerSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    buyerNote: z.string().nullish(),
    recipient: z.object({ id: z.number() }).nullish(),
    recipientSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    recipientNote: z.string().nullish(),
    currency: DocumentHeaderSchemaCurrencyEnum.nullish(),
    documentIsValued: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    warehouse: z.object({ id: z.number() }).nullish(),
    printed: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    noteBeforeLines: z.string().nullish(),
    noteAfterLines: z.string().nullish(),
    exchangeRate: z.number().nullish(),
    taxRegion: DocumentHeaderSchemaTaxRegionEnum,
    calculateTax: z.boolean().nullish(),
    deliveryType: DocumentHeaderSchemaDeliveryTypeEnum.nullish(),
    paymentType: DocumentHeaderSchemaPaymentTypeEnum.nullish(),
    carrier: z.object({ id: z.number() }).nullish(),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    recipientTotalPrice: z.number().nullish(),
    accountingUnitTotalPrice: z.number().nullish(),
    note: z.string().nullish(),
    totalWeightNetto: z.number().nullish(),
    totalRecycleFee: z.number().nullish()
});
export const DocumentLineSchema = BaseEntitySchema.extend({
    position: z.number().nullish(),
    code: z.string().nullish(),
    foreignCode: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    receivedInvoiceNumber: z.string().nullish(),
    text: z.string().nullish(),
    descriptionBelow: z.string().nullish(),
    quantity: z.number(),
    quantityCompleted: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    unit: DocumentLineSchemaUnitEnum.nullish(),
    vat: z.number().nullish(),
    tax: z.object({ id: z.number() }).nullish(),
    confirmState: DocumentLineSchemaConfirmStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Confirmed' : v)),
    domesticPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    price: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    bonusPriceAmount: z.number().nullish(),
    domesticBonusPriceAmount: z.number().nullish(),
    recipientPriceAmount: z.number().nullish(),
    recipientTotalPriceAmount: z.number().nullish(),
    recalculatePrices: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    lineItemType: DocumentLineSchemaLineItemTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Item' : v)),
    item: z.object({ id: z.number() }).nullish(),
    note: z.string().nullish(),
    totalWeightNetto: z.number().nullish(),
    totalRecycleFee: z.number().nullish()
});
export const BankAccountSchema = BaseEntitySchema.extend({
    name: z.string().nullish(),
    code: z.string().nullish(),
    country: BankAccountSchemaCountryEnum.nullish(),
    bankName: z.string().nullish(),
    accountNumber: z.string().nullish(),
    bankCode: z.string().nullish(),
    iban: z.string().nullish(),
    bic: z.string().nullish(),
    type: BankAccountSchemaTypeEnum.nullish(),
    party: z.object({ id: z.number() }).nullish()
});
export const IdentitySchema = z.object({
    id: z.number(),
    name: z.string(),
    code: z.string().nullish(),
    username: z.string().nullish(),
    roles: z.array(z.object({ id: z.number() })),
    password: z.string().nullish(),
    accessToken: z.string().nullish(),
    locale: IdentitySchemaLocaleEnum.nullish(),
    privateAccess: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    publicAccess: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    createdAt: z.coerce.date().nullish(),
    createdBy: z.object({ id: z.number() }).nullish(),
    updatedAt: z.coerce.date().nullish(),
    updatedBy: z.object({ id: z.number() }).nullish()
});
export const ScheduledTaskSchema = z.object({
    id: z.number().nullish(),
    taskName: z.string().nullish(),
    description: z.string().nullish(),
    cron: z.string(),
    timeoutSeconds: z.number().nullish(),
    enabled: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    data: z.any().nullish(),
    createdAt: z.coerce.date().nullish(),
    updatedAt: z.coerce.date().nullish()
});
export const IdentityRoleSchema = z.object({
    id: z.number().nullish(),
    label: z.string(),
    name: z.string(),
    permissions: z.any().nullish(),
    parentId: z.number().nullish()
});
export const PricelistRuleSchema = BaseEntitySchema.extend({
    name: z.string(),
    currency: PricelistRuleSchemaCurrencyEnum,
    filter: z.any().nullish(),
    surchargeType: PricelistRuleSchemaSurchargeTypeEnum,
    surchargeAmount: z.number().nullish(),
    surchargePercent: z.number().nullish(),
    ruleOrder: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v))
});
export const PartySchema = BaseEntitySchema.extend({
    name: z.string(),
    isBillingContact: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    isOrganization: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isSupplier: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    idNumber: z.string().nullish(),
    vatNumber: z.string().nullish(),
    code: z.string(),
    lawType: PartySchemaLawTypeEnum.nullish(),
    taxMode: PartySchemaTaxModeEnum.nullish(),
    language: PartySchemaLanguageEnum.nullish(),
    taxRegion: PartySchemaTaxRegionEnum,
    defaultPaymentType: PartySchemaDefaultPaymentTypeEnum.nullish(),
    invoiceDeliveryMethodType: PartySchemaInvoiceDeliveryMethodTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Print' : v)),
    invoiceDueDays: z.number().nullish().transform((v) => (v === null || v === undefined ? 14 : v)),
    street: z.string().nullish(),
    city: z.string().nullish(),
    tags: z.array(z.object({ id: z.number() })),
    tagsText: z.string(),
    zipCode: z.string().nullish(),
    country: PartySchemaCountryEnum.nullish(),
    gps: z.any().nullish(),
    timeWindows: z.any().nullish(),
    shipmentLineCode: z.string().nullish(),
    textMark: z.string().nullish(),
    approvedState: PartySchemaApprovedStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Pending' : v)),
    currency: PartySchemaCurrencyEnum,
    contactPersonName: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    notificationEmail: z.string().nullish(),
    creditLimit: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    bankAccounts: z.array(z.object({ id: z.number() })),
    deliverySenderInfo: z.string().nullish(),
    sepaMandateReference: z.string().nullish(),
    sepaMandateDateOfSignature: z.coerce.date().nullish(),
    batchInvoiceRule: z.object({ id: z.number() }).nullish(),
    salesman: z.object({ id: z.number() }).nullish(),
    note: z.string().nullish(),
    pricelists: z.array(z.object({ id: z.number() })),
    depositPricelist: z.object({ id: z.number() }).nullish(),
    parent: z.object({ id: z.number() }).nullish(),
    depositNumericSequence: z.object({ id: z.number() }).nullish(),
    pricelistCodes: z.string(),
    synchronizationItems: z.array(z.object({ id: z.number() })),
    noteForDriver: z.string().nullish()
});
export const PricelistSchema = BaseEntitySchema.extend({
    name: z.string(),
    type: PricelistSchemaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Default' : v)),
    code: z.string(),
    magisId: z.string().nullish(),
    currency: PricelistSchemaCurrencyEnum,
    country: PricelistSchemaCountryEnum,
    secondaryCurrencies: z.any().nullish(),
    useFixedExchangeRate: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    exchangeRate: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    items: z.array(z.object({ id: z.number() })),
    sourcePricelist: z.object({ id: z.number() }).nullish(),
    rules: z.array(z.object({ id: z.number() })),
    buyerDeliveryPricelist: z.object({ id: z.number() }).nullish(),
    deliveryPricelist: z.object({ id: z.number() }).nullish(),
    addCheapestDeliveryPrice: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    resolveDifferenceBuyerCarrierDelivery: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const PricelistItemSchema = BaseEntitySchema.extend({
    item: z.object({ id: z.number() }),
    price: z.number(),
    resolvedBuyerDeliveryFee: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    validFrom: z.coerce.date().nullish(),
    validTo: z.coerce.date().nullish(),
    minimalQuantityLimit: z.number().nullish(),
    addedDeliveryFee: z.number().nullish(),
    hash: z.string().nullish(),
    currency: PricelistItemSchemaCurrencyEnum,
    pricelist: z.object({ id: z.number() }),
    sourcePriceItem: z.object({ id: z.number() }).nullish()
});
export const SupplierStockItemSchema = BaseEntitySchema.extend({
    quantity: z.number(),
    priceNetto: z.number().nullish(),
    availableInDays: z.number().nullish(),
    currency: SupplierStockItemSchemaCurrencyEnum,
    supplier: z.object({ id: z.number() }),
    item: z.object({ id: z.number() })
});
export const InboundDeliveryOrderSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    documentNumber: z.string().nullish(),
    contractor: z.object({ id: z.number() }),
    contractorSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    documentType: z.object({ id: z.number() }),
    foreignOrderNumber: z.string().nullish(),
    assignedTo: z.object({ id: z.number() }).nullish(),
    state: InboundDeliveryOrderSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    allowScanUndefinedItems: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isPaused: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    requestDate: z.coerce.date().nullish(),
    lines: z.array(z.object({ id: z.number() })),
    warehouse: z.object({ id: z.number() }),
    inboundDelivery: z.object({ id: z.number() }).nullish(),
    inboundDocument: z.object({ id: z.number() }).nullish(),
    outboundDocument: z.object({ id: z.number() }).nullish()
});
export const CarrierSchema = BaseEntitySchema.extend({
    code: z.string(),
    name: z.string(),
    handler: CarrierSchemaHandlerEnum
});
export const BrandSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string().nullish()
});
export const InvoiceSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    documentNumber: z.string().nullish(),
    foreignInvoiceNumber: z.string().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    contractor: z.object({ id: z.number() }),
    buyerOrderNumber: z.string().nullish(),
    priceRounding: z.number().nullish(),
    taxRegion: InvoiceSchemaTaxRegionEnum,
    contractorSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    foreignOrderNumber: z.string().nullish(),
    currency: InvoiceSchemaCurrencyEnum.nullish(),
    exchangeRate: z.number().nullish(),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    archived: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    printed: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    issuedDate: z.coerce.date().nullish(),
    buyer: z.object({ id: z.number() }),
    buyerSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    state: InvoiceSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    documentType: z.object({ id: z.number() }),
    recipient: z.object({ id: z.number() }).nullish(),
    recipientSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    paymentType: InvoiceSchemaPaymentTypeEnum.nullish(),
    isBatchInvoice: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    agendaType: InvoiceSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'IssuedInvoice' : v)),
    correctionOriginalDocument: z.object({ id: z.number() }).nullish(),
    isCorrectionDocument: z.boolean().nullish(),
    bankAccount: z.object({ id: z.number() }).nullish(),
    bankAccountSnapshot: z.object({
        code: z.string().nullish(),
        accountName: z.string().nullish(),
        accountNumber: z.string().nullish(),
        bankName: z.string().nullish(),
        bankCode: z.string().nullish(),
        iban: z.string().nullish(),
        bic: z.string().nullish()
    }),
    variableSymbol: z.string().nullish(),
    taxableSupplyDate: z.coerce.date().nullish(),
    taxableSupplyDateIfDifferent: z.coerce.date().nullish(),
    dueDate: z.coerce.date(),
    domesticTotalPaidAmount: z.number().nullish(),
    totalPaidAmount: z.number().nullish(),
    deliveryType: InvoiceSchemaDeliveryTypeEnum.nullish(),
    carrier: z.object({ id: z.number() }).nullish(),
    penaltiesPercentage: z.number().nullish(),
    salesman: z.object({ id: z.number() }).nullish(),
    paymentState: InvoiceSchemaPaymentStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Unpaid' : v)),
    paymentResponsibility: z.string().nullish(),
    buyerIban: z.string().nullish(),
    buyerBic: z.string().nullish(),
    note: z.string().nullish(),
    sepaMandateReference: z.string().nullish(),
    sepaMandateSignatureDate: z.coerce.date().nullish(),
    lines: z.array(z.object({ id: z.number() })),
    taxLines: z.array(z.object({ id: z.number() })),
    payments: z.array(z.object({ id: z.number() })),
    sentByEmail: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isSelfBilling: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    creditNotes: z.array(z.object({ id: z.number() })),
    originalInvoice: z.object({ id: z.number() }).nullish(),
    saleOrder: z.object({ id: z.number() }).nullish(),
    calculateTax: z.boolean().nullish(),
    outboundDocuments: z.array(z.object({ id: z.number() })),
    sepaPayment: z.object({ id: z.number() }).nullish(),
    synchronizationItems: z.array(z.object({ id: z.number() })),
    totalWeightNetto: z.number().nullish(),
    totalRecycleFee: z.number().nullish(),
    markedAsPaidByBuyer: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const InvoiceLineSchema = DocumentLineSchema.extend({
    tax: z.object({ id: z.number() }).nullish(),
    customsTarrifCode: z.string().nullish(),
    productOriginCountry: z.string().nullish(),
    descriptionAbove: z.string().nullish(),
    invoice: z.object({ id: z.number() }).nullish(),
    warehouse: z.object({ id: z.number() }).nullish(),
    inboundDocumentLine: z.object({ id: z.number() }).nullish(),
    weightedAverageUnitCost: z.number().nullish(),
    weightedAverageUnitCostBonus: z.number().nullish(),
    accountingCreditSide: z.string().nullish(),
    accountingDebitSide: z.string().nullish()
});
export const InvoiceTaxLineSchema = BaseEntitySchema.extend({
    tax: z.object({ id: z.number() }).nullish(),
    vat: z.number(),
    domesticNettoAmount: z.number(),
    domesticBruttoAmount: z.number(),
    domesticTaxAmount: z.number(),
    nettoAmount: z.number().nullish(),
    bruttoAmount: z.number().nullish(),
    taxAmount: z.number().nullish(),
    invoice: z.object({ id: z.number() }).nullish()
});
export const InboundDeliveryOrderLineSchema = BaseEntitySchema.extend({
    position: z.number().nullish(),
    code: z.string().nullish(),
    foreignCode: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    receivedInvoiceNumber: z.string().nullish(),
    assignedTo: z.object({ id: z.number() }).nullish(),
    text: z.string().nullish(),
    descriptionBelow: z.string().nullish(),
    quantity: z.number(),
    unit: InboundDeliveryOrderLineSchemaUnitEnum.nullish(),
    vat: z.number().nullish(),
    tax: z.object({ id: z.number() }).nullish(),
    confirmState: InboundDeliveryOrderLineSchemaConfirmStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Confirmed' : v)),
    domesticPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    price: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    bonusPriceAmount: z.number().nullish(),
    domesticBonusPriceAmount: z.number().nullish(),
    recipientPriceAmount: z.number().nullish(),
    recipientTotalPriceAmount: z.number().nullish(),
    recalculatePrices: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    lineItemType: InboundDeliveryOrderLineSchemaLineItemTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Item' : v)),
    item: z.object({ id: z.number() }).nullish(),
    note: z.string().nullish(),
    totalWeightNetto: z.number().nullish(),
    totalRecycleFee: z.number().nullish(),
    stockItem: z.object({ id: z.number() }),
    quantityCompleted: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityRemaining: z.number(),
    blockQuantityUntilValuation: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    outboundDocumentLine: z.object({ id: z.number() }).nullish(),
    inboundDocumentLine: z.object({ id: z.number() }).nullish(),
    inboundDeliveryOrder: z.object({ id: z.number() }).nullish()
});
export const OutboundDeliveryOrderSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    documentNumber: z.string(),
    documentKindMask: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    buyerOrderNumber: z.string().nullish(),
    foreignInvoiceNumber: z.string().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    isDropshipping: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    issuedDate: z.coerce.date().nullish(),
    handPacking: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    archived: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    requestDate: z.coerce.date().nullish(),
    dispatchedAt: z.coerce.date().nullish(),
    state: OutboundDeliveryOrderSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    buyer: z.object({ id: z.number() }),
    buyerSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    buyerNote: z.string().nullish(),
    recipient: z.object({ id: z.number() }).nullish(),
    recipientSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    recipientNote: z.string().nullish(),
    currency: OutboundDeliveryOrderSchemaCurrencyEnum.nullish(),
    warehouse: z.object({ id: z.number() }).nullish(),
    deliveryType: OutboundDeliveryOrderSchemaDeliveryTypeEnum.nullish(),
    paymentType: OutboundDeliveryOrderSchemaPaymentTypeEnum.nullish(),
    carrier: z.object({ id: z.number() }).nullish(),
    recipientTotalPrice: z.number().nullish(),
    documentType: z.object({ id: z.number() }),
    lines: z.array(z.object({ id: z.number() })),
    packageUnits: z.array(z.object({ id: z.number() })),
    deliveryItems: z.array(z.object({ id: z.number() })),
    shipmentCreated: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    hasItemWithoutPackCapacity: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    assignedTo: z.object({ id: z.number() }).nullish(),
    deliveryPricelist: z.object({ id: z.number() }).nullish(),
    shipmentState: OutboundDeliveryOrderSchemaShipmentStateEnum.nullish(),
    variableSymbol: z.string().nullish(),
    outboundDocument: z.object({ id: z.number() }).nullish(),
    inboundDocument: z.object({ id: z.number() }).nullish(),
    itemsCount: z.number().nullish(),
    totalExpectedQuantity: z.number().nullish(),
    priority: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    shipmentRoute: z.object({ id: z.number() }).nullish(),
    loadShipmentStop: z.object({ id: z.number() }).nullish(),
    unloadShipmentStop: z.object({ id: z.number() }).nullish()
});
export const OutboundDeliveryOrderLineSchema = BaseEntitySchema.extend({
    position: z.number().nullish(),
    stockItem: z.object({ id: z.number() }),
    quantity: z.number(),
    quantityNowLoaded: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityPicked: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityChecked: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityPickedToLoad: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityLoaded: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityPacked: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityDispatched: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityPickRemaining: z.number().nullish(),
    totalWeightNetto: z.number().nullish(),
    note: z.string().nullish(),
    stockItemReservation: z.object({ id: z.number() }),
    assignedTo: z.object({ id: z.number() }).nullish(),
    stagingLocation: z.object({ id: z.number() }).nullish(),
    deliveryItems: z.array(z.object({ id: z.number() })),
    handlingUnit: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    outboundDocumentLine: z.object({ id: z.number() }).nullish(),
    inboundDocumentLine: z.object({ id: z.number() }).nullish()
});
export const KeyValueStoreSchema = BaseEntitySchema.extend({
    key: z.string(),
    value: z.any()
});
export const OutboundQueueSchema = BaseEntitySchema.extend({
    name: z.string(),
    documentType: z.object({ id: z.number() }),
    type: OutboundQueueSchemaTypeEnum,
    warehouse: z.object({ id: z.number() }),
    rule: z.any().nullish(),
    cumulativeOutbound: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    gridConfiguration: z.any().nullish(),
    isFolder: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    parent: z.object({ id: z.number() }).nullish(),
    limitToTerminalConfigurations: z.array(z.object({ id: z.number() })).nullish(),
    shipmentRouteLinks: z.array(z.object({ id: z.number() })).nullish()
});
export const SaleOrderLineSchema = BaseEntitySchema.extend({
    position: z.number().nullish(),
    code: z.string().nullish(),
    foreignCode: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    receivedInvoiceNumber: z.string().nullish(),
    text: z.string().nullish(),
    descriptionBelow: z.string().nullish(),
    quantity: z.number(),
    unit: SaleOrderLineSchemaUnitEnum.nullish(),
    vat: z.number().nullish(),
    tax: z.object({ id: z.number() }).nullish(),
    confirmState: SaleOrderLineSchemaConfirmStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Confirmed' : v)),
    domesticPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    price: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    bonusPriceAmount: z.number().nullish(),
    domesticBonusPriceAmount: z.number().nullish(),
    recipientPriceAmount: z.number().nullish(),
    recipientTotalPriceAmount: z.number().nullish(),
    recalculatePrices: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    lineItemType: SaleOrderLineSchemaLineItemTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Item' : v)),
    item: z.object({ id: z.number() }).nullish(),
    note: z.string().nullish(),
    totalWeightNetto: z.number().nullish(),
    totalRecycleFee: z.number().nullish(),
    quantityReserved: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityReservedCovered: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityReservedUncovered: z.number().nullish(),
    warehouse: z.object({ id: z.number() }).nullish(),
    quantityOutbound: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityFulfilment: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    saleOrder: z.object({ id: z.number() }),
    outboundDocumentLines: z.array(z.object({ id: z.number() })).nullish()
});
export const SaleOrderSchema = DocumentHeaderSchema.extend({
    documentType: z.object({ id: z.number() }),
    salesChannel: z.object({ id: z.number() }).nullish(),
    excludeFromStatistics: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    lines: z.array(z.object({ id: z.number() })),
    deliveryType: SaleOrderSchemaDeliveryTypeEnum,
    paymentType: SaleOrderSchemaPaymentTypeEnum,
    validationState: SaleOrderSchemaValidationStateEnum.nullish(),
    validationMessage: z.string().nullish(),
    deliveryPricelist: z.object({ id: z.number() }).nullish(),
    buyerDeliveryPricelist: z.object({ id: z.number() }).nullish(),
    isDropshipping: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    outboundState: SaleOrderSchemaOutboundStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'None' : v)),
    reservationState: SaleOrderSchemaReservationStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'None' : v)),
    fulfilmentState: SaleOrderSchemaFulfilmentStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    paymentState: SaleOrderSchemaPaymentStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Unpaid' : v)),
    domesticTotalPaidAmount: z.number().nullish(),
    totalPaidAmount: z.number().nullish(),
    salesman: z.object({ id: z.number() }).nullish(),
    iban: z.string().nullish(),
    bic: z.string().nullish(),
    automationState: SaleOrderSchemaAutomationStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'None' : v)),
    sepaMandateReference: z.string().nullish(),
    isMultiWarehouse: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    sepaMandateDateOfSignature: z.coerce.date().nullish(),
    outboundDocuments: z.array(z.object({ id: z.number() })),
    ediInboundOrder: z.object({ id: z.number() }).nullish(),
    invoices: z.array(z.object({ id: z.number() })),
    totalCatalogQuantity: z.number().nullish(),
    deliveryShipmentTimeWindows: z.any().nullish(),
    setRequestToPickup: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    pickupPinCode: z.string().nullish(),
    endCustomer: z.object({ id: z.number() }).nullish(),
    endCustomerVehicle: z.object({ id: z.number() }).nullish(),
    endCustomerVisitDate: z.coerce.date().nullish(),
    buyerStornoReason: z.string().nullish()
});
export const HandlingUnitTypeSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string().nullish(),
    fixedType: HandlingUnitTypeSchemaFixedTypeEnum
});
export const HandlingUnitSchema = BaseEntitySchema.extend({
    code: z.string(),
    type: z.object({ id: z.number() }),
    state: HandlingUnitSchemaStateEnum,
    storageLocation: z.object({ id: z.number() }).nullish(),
    externalLocation: HandlingUnitSchemaExternalLocationEnum,
    externalParty: z.object({ id: z.number() }).nullish(),
    totalStockItemQuantity: z.number().nullish()
});
export const ItemCodeTypeSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string()
});
export const ItemCodeSchema = BaseEntitySchema.extend({
    code: z.string(),
    type: z.object({ id: z.number() }),
    item: z.object({ id: z.number() }).nullish()
});
export const ItemSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string(),
    trackQuantity: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    isUnpriced: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    organization: z.object({ id: z.number() }).nullish(),
    manufacturer: z.object({ id: z.number() }).nullish(),
    perex: z.string().nullish(),
    codes: z.array(z.object({ id: z.number() })),
    description: z.string().nullish(),
    quantity: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityAvailable: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityUnconfirmed: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityUnvalued: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityReserved: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityOutbound: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityOrdered: z.number().nullish(),
    quantityStore: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityStoreAvailable: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    fifoUnitCost: z.number().nullish(),
    weightedAverageUnitCost: z.number().nullish(),
    weightedAverageUnitCostBonus: z.number().nullish(),
    manufacturerCode: z.string().nullish(),
    manufacturersPrice: z.number().nullish(),
    price: z.number().nullish(),
    priceEur: z.number().nullish(),
    vat: z.number().nullish(),
    currency: ItemSchemaCurrencyEnum.nullish(),
    itemCategory: z.object({ id: z.number() }).nullish(),
    ean: z.string().nullish(),
    unit: z.string().nullish(),
    tax: z.object({ id: z.number() }).nullish(),
    weightKg: z.number().nullish(),
    customsTarrifCode: z.string().nullish(),
    recycleFeeAmount: z.number().nullish(),
    type: ItemSchemaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Catalog' : v)),
    productionBatchEvidence: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    disableManualCreate: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    invoiceDescription: z.string().nullish(),
    inventoryItems: z.array(z.object({ id: z.number() })).nullish(),
    clearingPrescription: z.object({ id: z.number() }).nullish(),
    shipmentCapacity: z.number().nullish(),
    oneDimensionPackageCapacity: z.number().nullish(),
    note: z.string().nullish(),
    parameters: z.object({ id: z.number() }),
    synchronizationItems: z.array(z.object({ id: z.number() })).nullish(),
    reporting: z.object({ id: z.number() }).nullish()
});
export const ItemParametersSchema = z.object({
    id: z.number().nullish(),
    item: z.object({ id: z.number() }),
    tire: z.object({ id: z.number() }).nullish()
});
export const ItemParametersTireSchema = z.object({
    id: z.number(),
    itemParameters: z.object({ id: z.number() }),
    tireSeason: ItemParametersTireSchemaTireSeasonEnum.nullish(),
    selectionCriteria: z.string().nullish(),
    dezen: z.string().nullish(),
    tireGroup: z.string().nullish(),
    tireWidth: z.number().nullish(),
    tireWidthText: z.string().nullish(),
    tireProfile: z.string().nullish(),
    rim: z.number().nullish(),
    rimText: z.string().nullish(),
    speedIndex: z.string().nullish(),
    loadIndex: z.string().nullish(),
    loadIndexText: z.string().nullish(),
    rollingResistance: z.string().nullish(),
    noise: z.string().nullish(),
    outsideNoise: z.string().nullish(),
    rofEmtDsst: z.string().nullish(),
    tireCt: z.string().nullish(),
    tireMarks: z.string().nullish(),
    wetGrip: z.string().nullish(),
    tireOe: z.string().nullish(),
    tireOeLong: z.string().nullish(),
    tireEt: z.string().nullish(),
    tirePr: z.string().nullish(),
    tireType: z.string().nullish(),
    eprelLink: z.string().nullish(),
    tireConstruction: z.string().nullish(),
    whiteLabelText: z.boolean().nullish(),
    isNew: z.boolean().nullish(),
    isComingSoon: z.boolean().nullish(),
    isPriceAction: z.boolean().nullish(),
    isRecommended: z.boolean().nullish(),
    isBestSelling: z.boolean().nullish(),
    noEshop: z.boolean().nullish(),
    searchTerm: z.string().nullish(),
    successor: z.string().nullish(),
    availability: z.string().nullish(),
    certificate: z.string().nullish(),
    fuelEconomy: z.string().nullish(),
    test: z.string().nullish(),
    testRanking: z.string().nullish(),
    wheelStuds: z.string().nullish(),
    wheelPitch: z.string().nullish(),
    wheelPitchCircle: z.string().nullish(),
    markConstant: z.string().nullish(),
    statisticalField1: z.string().nullish(),
    statisticalField2: z.string().nullish(),
    statisticalField3: z.string().nullish(),
    statisticalField4: z.string().nullish(),
    statisticalField5: z.string().nullish(),
    statisticalField6: z.string().nullish(),
    statisticalField7: z.string().nullish(),
    statisticalField8: z.string().nullish(),
    statisticalField9: z.string().nullish(),
    statisticalField10: z.string().nullish(),
    dotDemoInfo: z.string().nullish(),
    imageUrl: z.string().nullish(),
    mountainSnowFlake: z.string().nullish(),
    magisStatisticalGroup: z.string().nullish(),
    magisCategory: z.string().nullish(),
    magisSubCategory: z.string().nullish(),
    tireOriginCountry: z.string().nullish(),
    circumference: z.number().nullish(),
    volumetricWeight: z.number().nullish()
});
export const OutboundRuleSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    scheduledTask: z.object({ id: z.number() }).nullish(),
    priority: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    defaultRequestedDateExpression: z.any().nullish(),
    filterDocumentTypes: z.array(z.object({ id: z.number() })),
    filterRecipients: z.array(z.object({ id: z.number() })),
    groupRecipient: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    groupItem: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    documentMaximumQuantity: z.number().nullish()
});
export const StockItemLocationSchema = BaseEntitySchema.extend({
    stockItem: z.object({ id: z.number() }),
    quantity: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityAvailable: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    storageLocation: z.object({ id: z.number() }),
    batch: z.number().nullish(),
    originCountry: StockItemLocationSchemaOriginCountryEnum.nullish(),
    handlingUnit: z.object({ id: z.number() }).nullish(),
    blockedByStockTake: z.object({ id: z.number() }).nullish()
});
export const StockItemSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }).nullish(),
    item: z.object({ id: z.number() }),
    quantity: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityAvailable: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityReserved: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    stockItemLocations: z.array(z.object({ id: z.number() })),
    stockItemMovements: z.array(z.object({ id: z.number() })),
    accountingUnitPrice: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v))
});
export const NestUserSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string().nullish(),
    email: z.string(),
    identity: z.object({ id: z.number() }),
    terminalConfiguration: z.object({ id: z.number() }).nullish(),
    hasActiveWarehouseMove: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    activeCumulativeOutboundForQueue: z.object({ id: z.number() }).nullish()
});
export const StorageLocationSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string(),
    type: StorageLocationSchemaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Default' : v)),
    belongsToUser: z.object({ id: z.number() }).nullish(),
    positionOrder: z.number().nullish(),
    positionX: z.number().nullish(),
    positionY: z.number().nullish(),
    row: z.number().nullish(),
    hall: z.number().nullish(),
    column: z.number().nullish(),
    floor: z.number().nullish(),
    warehouse: z.object({ id: z.number() }),
    warehouseSubInventory: z.object({ id: z.number() }).nullish(),
    moveHandlingUnitToLocationWhenEmpty: z.object({ id: z.number() }).nullish()
});
export const ActivitySchema = BaseEntitySchema.extend({
    identity: z.object({ id: z.number() }),
    message: z.string(),
    description: z.string().nullish(),
    messageKey: z.string().nullish(),
    translateData: z.any().nullish(),
    modelName: z.string(),
    modelId: z.number()
});
export const NumericSequenceSchema = BaseEntitySchema.extend({
    name: z.string(),
    lifespan: NumericSequenceSchemaLifespanEnum,
    prefix: z.string().nullish().transform((v) => (v === null || v === undefined ? '' : v)),
    prefixTwoDigitYear: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    prefixCode: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    currentValue: z.number(),
    items: z.array(z.object({ id: z.number() })),
    requestedLength: z.number(),
    type: NumericSequenceSchemaTypeEnum.nullish()
});
export const StockItemMovementSchema = BaseEntitySchema.extend({
    sku: z.object({ id: z.number() }),
    quantity: z.number(),
    skuDirectionType: StockItemMovementSchemaSkuDirectionTypeEnum,
    isCorrection: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isHandlingUnitMove: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isGoodsIssue: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    originCountry: StockItemMovementSchemaOriginCountryEnum.nullish(),
    productionBatch: z.number().nullish(),
    sourceWarehouseLocation: z.object({ id: z.number() }).nullish(),
    destinationWarehouseLocation: z.object({ id: z.number() }).nullish(),
    sourcePalette: z.object({ id: z.number() }).nullish(),
    expectedOutbound: z.object({ id: z.number() }).nullish(),
    expectedInbound: z.object({ id: z.number() }).nullish(),
    destinationPalette: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    inboundDeliveryOrderLine: z.object({ id: z.number() }).nullish()
});
export const ItemMovementSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    directionType: ItemMovementSchemaDirectionTypeEnum,
    item: z.object({ id: z.number() }),
    documentDate: z.coerce.date(),
    quantity: z.number(),
    domesticPriceNetto: z.number().nullish(),
    domesticBonusPriceNetto: z.number().nullish(),
    updatedBySource: z.string().nullish(),
    stockBalance: z.number().nullish(),
    weightedAverageCost: z.number().nullish(),
    weightedAverageBonusCost: z.number().nullish(),
    outboundDocumentLine: z.object({ id: z.number() }),
    inboundDocumentLine: z.object({ id: z.number() })
});
export const OutboundDeliverySchema = BaseEntitySchema.extend({
    type: z.object({ id: z.number() }),
    lines: z.array(z.object({ id: z.number() })),
    totalQuantity: z.number().nullish(),
    completedDate: z.coerce.date().nullish(),
    outboundDeliveryOrder: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() })
});
export const OutboundDeliveryLineSchema = BaseEntitySchema.extend({
    sku: z.object({ id: z.number() }),
    handlingUnit: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrderLine: z.object({ id: z.number() }),
    outboundDelivery: z.object({ id: z.number() }).nullish()
});
export const InboundDeliverySchema = BaseEntitySchema.extend({
    type: z.object({ id: z.number() }),
    lines: z.array(z.object({ id: z.number() })),
    warehouse: z.object({ id: z.number() }),
    inboundDeliveryOrder: z.object({ id: z.number() }).nullish()
});
export const InboundDeliveryLineSchema = BaseEntitySchema.extend({
    stockItem: z.object({ id: z.number() }),
    handlingUnit: z.object({ id: z.number() }).nullish(),
    inboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    inboundDelivery: z.object({ id: z.number() }).nullish()
});
export const CustomPrintTemplateSchema = BaseEntitySchema.extend({
    name: z.string(),
    scope: z.any().nullish(),
    entityName: z.string().nullish(),
    fragmentPaths: z.any().nullish(),
    template: z.string(),
    parametersDefinition: z.any().nullish(),
    defaultNumberOfCopies: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v))
});
export const WarehouseMoveItemSchema = BaseEntitySchema.extend({
    stockItem: z.object({ id: z.number() }).nullish(),
    palette: z.object({ id: z.number() }).nullish(),
    quantity: z.number(),
    batch: z.number().nullish(),
    originCountry: z.string().nullish(),
    state: WarehouseMoveItemSchemaStateEnum,
    sourceWarehouseLocation: z.object({ id: z.number() }).nullish(),
    destinationWarehouseLocation: z.object({ id: z.number() }).nullish(),
    warehouseMove: z.object({ id: z.number() })
});
export const WarehouseMoveSchema = BaseEntitySchema.extend({
    items: z.array(z.object({ id: z.number() })),
    warehouse: z.object({ id: z.number() }),
    type: WarehouseMoveSchemaTypeEnum
});
export const PaymentSchema = BaseEntitySchema.extend({
    amount: z.number(),
    domesticAmount: z.number(),
    currency: PaymentSchemaCurrencyEnum,
    exchangeRate: z.number().nullish(),
    type: PaymentSchemaTypeEnum.nullish(),
    paymentDate: z.coerce.date(),
    invoice: z.object({ id: z.number() }).nullish(),
    synchronizationItems: z.array(z.object({ id: z.number() })).nullish()
});
export const HandlingUnitMovementSchema = BaseEntitySchema.extend({
    handlingUnit: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }),
    sourceWarehouseLocation: z.object({ id: z.number() }).nullish(),
    destinationWarehouseLocation: z.object({ id: z.number() }).nullish(),
    sourceParty: z.object({ id: z.number() }).nullish(),
    destinationParty: z.object({ id: z.number() }).nullish()
});
export const EdiInboundOrderSchema = BaseEntitySchema.extend({
    salesChannel: z.object({ id: z.number() }),
    foreignOrderNumber: z.string(),
    state: EdiInboundOrderSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Received' : v)),
    order: z.object({ id: z.number() }).nullish(),
    events: z.array(z.object({ id: z.number() })),
    stateMessages: z.string().nullish(),
    accepted: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    responded: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    invoiceSent: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    trackingNumbersSent: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    partnerNotified: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    ediInboundBuffer: z.object({ id: z.number() }).nullish()
});
export const EdiInboundOrderEventSchema = BaseEntitySchema.extend({
    type: EdiInboundOrderEventSchemaTypeEnum,
    raw: z.string().nullish(),
    data: z.any().nullish(),
    inboundOrder: z.object({ id: z.number() })
});
export const EdiInboundBufferSchema = BaseEntitySchema.extend({
    salesChannel: z.object({ id: z.number() }),
    raw: z.string(),
    state: EdiInboundBufferSchemaStateEnum,
    syncBufferId: z.number().nullish(),
    syncEshopId: z.number().nullish()
});
export const ParcelDeliveryDpdCountrySchema = z.object({
    countryName: z.string(),
    countryCodeNumeric: z.number(),
    countryCodeAlpha2: z.string(),
    countryCodeAlpha3: z.string(),
    version: z.string()
});
export const ParcelDeliveryDpdRouteSchema = z.object({
    destinationCountryAlpha: z.string(),
    destinationCountryNumber: z.string(),
    networkCode: z.number().nullish(),
    beginPostCode: z.string().nullish(),
    endPostCode: z.string().nullish(),
    soCode: z.number(),
    asCode: z.string().nullish(),
    buAlpha: z.string(),
    buNumber: z.number(),
    dDepot: z.number(),
    sSort: z.string().nullish(),
    dSort: z.string().nullish(),
    oSort: z.string().nullish(),
    cSort: z.string().nullish(),
    barcodeId: z.string(),
    version: z.string()
});
export const DeliveryFeeCalculatorSchema = BaseEntitySchema.extend({
    name: z.string(),
    items: z.array(z.object({ id: z.number() }))
});
export const DeliveryFeeCalculatorItemSchema = BaseEntitySchema.extend({
    description: z.string(),
    rule: z.any(),
    itemFee: z.number().nullish(),
    packageFee: z.number().nullish(),
    packageMaxQuantity: z.number().nullish(),
    deliveryFeeCalculator: z.object({ id: z.number() }),
    product: z.object({ id: z.number() }).nullish()
});
export const ExchangeRateSchema = BaseEntitySchema.extend({
    currency: ExchangeRateSchemaCurrencyEnum,
    rate: z.number(),
    isFixed: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    date: z.coerce.date().nullish()
});
export const DocumentSerieSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    code: z.string(),
    accountingMovementTypeCode: z.string().nullish(),
    name: z.string(),
    agendaType: DocumentSerieSchemaAgendaTypeEnum,
    documentNumericSequence: z.object({ id: z.number() })
});
export const WarehouseSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string(),
    includeInTotalStocks: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    organization: z.object({ id: z.number() }),
    office: z.object({ id: z.number() }).nullish(),
    dpdData: z.any().nullish(),
    dpdDataSk: z.any().nullish(),
    address: z.string().nullish(),
    carriers: z.array(z.object({ id: z.number() })),
    proportionalDistribution: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    openingHours: z.any().nullish()
});
export const PackageUnitSchema = BaseEntitySchema.extend({
    type: z.object({ id: z.number() }),
    deliveryType: PackageUnitSchemaDeliveryTypeEnum,
    consignmentNumber: z.string().nullish(),
    parcelNumber: z.string().nullish(),
    packedAt: z.coerce.date().nullish(),
    variableSymbol: z.string().nullish(),
    recipientSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    senderInfo: z.string().nullish(),
    label: z.string().nullish(),
    carrierData: z.any().nullish(),
    lastTrackingUpdate: z.coerce.date().nullish(),
    weightKg: z.number().nullish(),
    indexInPackage: z.number().nullish(),
    cashOnDeliveryAmount: z.number().nullish(),
    cashOnDeliveryCurrency: PackageUnitSchemaCashOnDeliveryCurrencyEnum.nullish(),
    cashOnDeliveryBankAccount: z.object({
        code: z.string().nullish(),
        accountName: z.string().nullish(),
        accountNumber: z.string().nullish(),
        bankName: z.string().nullish(),
        bankCode: z.string().nullish(),
        iban: z.string().nullish(),
        bic: z.string().nullish()
    }),
    state: PackageUnitSchemaStateEnum,
    deliveryStatus: PackageUnitSchemaDeliveryStatusEnum,
    packedByMachine: z.object({ id: z.number() }).nullish(),
    packingLineDockLocation: z.object({ id: z.number() }).nullish(),
    deliveryItems: z.array(z.object({ id: z.number() })),
    outboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    consignmentNoteLine: z.object({ id: z.number() }).nullish(),
    volumetricWeightKg: z.number().nullish(),
    widthCm: z.number().nullish(),
    heightCm: z.number().nullish(),
    circumferenceCm: z.number().nullish(),
    expectedCost: z.number().nullish(),
    estimatedDelivery: z.coerce.date().nullish(),
    actualDelivery: z.coerce.date().nullish(),
    carrierStatusRawData: z.any().nullish(),
    events: z.array(z.object({ id: z.number() }))
});
export const PackageUnitEventSchema = BaseEntitySchema.extend({
    packageUnit: z.object({ id: z.number() }),
    timestamp: z.coerce.date(),
    status: PackageUnitEventSchemaStatusEnum,
    description: z.string().nullish(),
    carrierCode: z.string().nullish()
});
export const PackageTypeSchema = BaseEntitySchema.extend({
    code: z.string().nullish(),
    name: z.string(),
    numericSequence: z.object({ id: z.number() }).nullish(),
    countries: z.any().nullish(),
    handler: PackageTypeSchemaHandlerEnum,
    carrier: z.object({ id: z.number() }).nullish(),
    parameters: z.any().nullish(),
    maximumQuantity: z.number().nullish(),
    oneDimensionCapacity: z.number().nullish()
});
export const PackageSimulationSchema = BaseEntitySchema.extend({
    name: z.string(),
    settings: z.any(),
    status: PackageSimulationSchemaStatusEnum.nullish().transform((v) => (v === null || v === undefined ? 'Pending' : v)),
    startedAt: z.coerce.date().nullish(),
    finishedAt: z.coerce.date().nullish(),
    result: z.any().nullish()
});
export const PrinterSchema = BaseEntitySchema.extend({
    label: z.string(),
    code: z.string(),
    type: PrinterSchemaTypeEnum,
    address: z.string(),
    port: z.number().nullish(),
    location: z.string().nullish(),
    isTest: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const StockItemReservationSchema = BaseEntitySchema.extend({
    stockItemLocation: z.object({ id: z.number() }),
    quantity: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    picker: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    staggingDocumentType: z.object({ id: z.number() }).nullish()
});
export const ApplicationParameterSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string().nullish(),
    value: z.any()
});
export const DeliveryItemSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    handlingUnit: z.object({ id: z.number() }).nullish(),
    packageUnit: z.object({ id: z.number() }).nullish(),
    quantity: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    outboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    tireBarcode: z.string().nullish()
});
export const ShipmentRouteSchema = BaseEntitySchema.extend({
    documentNumber: z.string(),
    type: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }),
    state: ShipmentRouteSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Draft' : v)),
    isLoaded: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    driver: z.object({ id: z.number() }).nullish(),
    vehicle: z.object({ id: z.number() }).nullish(),
    stops: z.array(z.object({ id: z.number() })),
    outboundDocuments: z.array(z.object({ id: z.number() })),
    inboundShipments: z.array(z.object({ id: z.number() })),
    startAt: z.coerce.date().nullish(),
    endAt: z.coerce.date().nullish(),
    geometry: z.string().nullish(),
    cost: z.number().nullish(),
    distanceInMeters: z.number().nullish(),
    shipmentDocumentChecked: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    vehicleSettingsSnapshot: z.any().nullish(),
    startLoadingAt: z.coerce.date().nullish(),
    endLoadingAt: z.coerce.date().nullish()
});
export const ShipmentRouteTypeSchema = BaseEntitySchema.extend({
    name: z.string(),
    timeRangeStart: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    timeRangeEnd: z.number().nullish().transform((v) => (v === null || v === undefined ? 86400 : v)),
    warehouse: z.object({ id: z.number() }),
    shipmentArea: z.object({ id: z.number() }),
    shipmentVehicles: z.array(z.object({ id: z.number() })),
    code: z.string().nullish(),
    numericSequence: z.object({ id: z.number() }),
    requireInboundPhoto: z.boolean().nullish(),
    requireInboundSkuScan: z.boolean().nullish(),
    requireInboundPaletteScan: z.boolean().nullish(),
    shipmentTypeVehicleSettings: z.array(z.object({ id: z.number() })),
    softLimitsToTimeWindowEndInSeconds: z.any().nullish(),
    disableAutoPlanning: z.boolean().nullish(),
    outboundDocumentTypes: z.array(z.object({ id: z.number() })),
    baseLocation: z.object({ id: z.number() }).nullish()
});
export const ShipmentVehicleSchema = BaseEntitySchema.extend({
    name: z.string(),
    driver: z.object({ id: z.number() }).nullish(),
    start: z.object({ id: z.number() }),
    end: z.object({ id: z.number() }),
    color: z.string().nullish(),
    note: z.string().nullish(),
    shipmentLineCode: z.string().nullish(),
    isOutOfService: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    shipmentMaximumCapacity: z.number().nullish(),
    timeWindow: z.any().nullish(),
    costPerRouteFixed: z.number().nullish(),
    costPerRoutePerHour: z.number().nullish(),
    costPerRoutePerKm: z.number().nullish(),
    maxDistance: z.number().nullish(),
    maxDistancePerDayKilometers: z.number().nullish(),
    maxTravelTimePerDayMinutes: z.number().nullish(),
    maxTravelTime: z.number().nullish(),
    trackingVehicleId: z.string().nullish(),
    lastPosition: z.any().nullish(),
    maxStops: z.number().nullish(),
    speedFactor: z.number().nullish(),
    shipmentRouteTypes: z.array(z.object({ id: z.number() })),
    warehouse: z.object({ id: z.number() })
});
export const ShipmentStopSchema = BaseEntitySchema.extend({
    description: z.string().nullish(),
    turn: z.number(),
    type: ShipmentStopSchemaTypeEnum,
    eta: z.coerce.date().nullish(),
    etaLive: z.coerce.date().nullish(),
    estimatedDurationMinutes: z.number().nullish(),
    serviceInSeconds: z.number().nullish(),
    setupInSeconds: z.number().nullish(),
    waitingTimeInSeconds: z.number().nullish(),
    vehicleLoadAfterStopDispatch: z.number().nullish(),
    computedTimeWindow: z.any().nullish(),
    state: ShipmentStopSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    skipReason: z.string().nullish(),
    party: z.object({ id: z.number() }).nullish(),
    gps: z.any().nullish(),
    addressText: z.string().nullish(),
    clientName: z.string().nullish(),
    activeUnloadOutboundDocuments: z.array(z.object({ id: z.number() })),
    activeLoadOutboundDocuments: z.array(z.object({ id: z.number() })),
    activeUnloadInboundShipments: z.array(z.object({ id: z.number() })),
    activeLoadInboundShipments: z.array(z.object({ id: z.number() })),
    assignments: z.array(z.object({ id: z.number() })),
    arrivalAt: z.coerce.date().nullish(),
    gpsArrivalAt: z.coerce.date().nullish(),
    gpsDepartureAt: z.coerce.date().nullish(),
    completedAt: z.coerce.date().nullish(),
    shipmentRoute: z.object({ id: z.number() }).nullish(),
    travelToNextStopDurationInSeconds: z.number().nullish(),
    travelToNextStopData: z.any().nullish()
});
export const ShipmentStopAssignmentSchema = BaseEntitySchema.extend({
    shipmentStop: z.object({ id: z.number() }),
    outboundDocument: z.object({ id: z.number() }).nullish(),
    inboundShipment: z.object({ id: z.number() }).nullish(),
    action: ShipmentStopAssignmentSchemaActionEnum
});
export const NestSentMailSchema = z.object({
    id: z.number(),
    from: z.string(),
    to: z.string(),
    subject: z.string().nullish(),
    text: z.string().nullish(),
    html: z.string().nullish(),
    createdAt: z.coerce.date(),
    sentAt: z.coerce.date().nullish(),
    attachments: z.any().nullish(),
    serverResponse: z.string().nullish()
});
export const OrganizationPricelistSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string().nullish(),
    items: z.array(z.object({ id: z.number() }))
});
export const OrganizationPricelistItemSchema = BaseEntitySchema.extend({
    price: z.number(),
    priority: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    destinationParty: z.object({ id: z.number() }).nullish(),
    documentType: z.object({ id: z.number() }).nullish(),
    skuParametersFilter: z.any().nullish(),
    description: z.string().nullish(),
    validFrom: z.coerce.date().nullish(),
    validTo: z.coerce.date().nullish(),
    pricelist: z.object({ id: z.number() })
});
export const StockTakeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    warehouse: z.object({ id: z.number() }),
    inboundDeliveryOrderDocumentType: z.object({ id: z.number() }),
    outboundDeliveryOrderDocumentType: z.object({ id: z.number() }),
    state: StockTakeSchemaStateEnum,
    items: z.array(z.object({ id: z.number() })),
    canUnplanned: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    startedAt: z.coerce.date().nullish()
});
export const StockTakeItemSchema = BaseEntitySchema.extend({
    warehouseLocation: z.object({ id: z.number() }),
    palette: z.object({ id: z.number() }).nullish(),
    sku: z.object({ id: z.number() }).nullish(),
    batch: z.number().nullish(),
    originCountry: z.string().nullish(),
    skuLocation: z.object({ id: z.number() }).nullish(),
    state: StockTakeItemSchemaStateEnum,
    expectedQuantity: z.number(),
    stockTakeQuantity: z.number().nullish(),
    quantityDifference: z.number().nullish(),
    completedAt: z.coerce.date().nullish(),
    stockTake: z.object({ id: z.number() }),
    isUnplanned: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const StorageInventorySchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string(),
    organization: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }),
    shipmentRouteLink: z.object({ id: z.number() }).nullish()
});
export const ShipmentRouteRuleSchema = BaseEntitySchema.extend({
    name: z.string(),
    scheduledTask: z.object({ id: z.number() }).nullish(),
    priority: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    applyShipmentRouteType: z.object({ id: z.number() }),
    outboundDocumentRule: z.any().nullish(),
    vehicleRule: z.any().nullish()
});
export const IdentityPreferencesSchema = BaseEntitySchema.extend({
    application: z.string(),
    key: z.string(),
    value: z.any(),
    identity: z.object({ id: z.number() })
});
export const PersonalizedListSchema = BaseEntitySchema.extend({
    name: z.string(),
    entityName: z.string(),
    definition: z.any(),
    isFavorite: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isNotify: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    notifyCheckLastUpdatedAt: z.coerce.date().nullish()
});
export const SupplierPricelistSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string(),
    currency: SupplierPricelistSchemaCurrencyEnum,
    supplier: z.object({ id: z.number() }),
    items: z.array(z.object({ id: z.number() }))
});
export const SupplierPricelistItemSchema = BaseEntitySchema.extend({
    priceType: z.object({ id: z.number() }),
    product: z.object({ id: z.number() }),
    price: z.number(),
    validFrom: z.coerce.date(),
    validTo: z.coerce.date().nullish(),
    pricelist: z.object({ id: z.number() }),
    deletedAt: z.coerce.date().nullish()
});
export const DocumentTemplateSchema = BaseEntitySchema.extend({
    name: z.string(),
    dueDateIntervalDays: z.number(),
    noteAfterLines: z.string().nullish(),
    noteBeforeLines: z.string().nullish()
});
export const SupplierStockImportSchema = BaseEntitySchema.extend({
    name: z.string(),
    currency: SupplierStockImportSchemaCurrencyEnum,
    type: z.string(),
    scheduledTask: z.object({ id: z.number() }).nullish(),
    organization: z.object({ id: z.number() }),
    supplier: z.object({ id: z.number() }),
    availableInDays: z.number().nullish(),
    downloadUrl: z.string().nullish(),
    ftpConnection: z.any().nullish(),
    dir: z.string().nullish(),
    filenamePattern: z.string().nullish(),
    deleteFileAfterImport: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    csvFromLine: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    csvImportColumnProductEan: z.number().nullish(),
    csvImportColumnProductManufacturerCode: z.number().nullish(),
    csvImportColumnProductCode: z.number().nullish(),
    csvImportColumnProductQuantity: z.number().nullish(),
    csvImportColumnProductPrice: z.number().nullish()
});
export const MachineSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string(),
    handler: z.string(),
    isActive: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    options: z.any().nullish(),
    warehouse: z.object({ id: z.number() }),
    user: z.object({ id: z.number() }),
    packingLineStoreLocation: z.object({ id: z.number() }).nullish(),
    defaultPrinter: z.object({ id: z.number() }).nullish(),
    host: z.string()
});
export const PredefinedTextSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string().nullish(),
    type: z.string(),
    templates: z.any().nullish()
});
export const DeliveryTypeToPaymentTypeSchema = BaseEntitySchema.extend({
    paymentType: DeliveryTypeToPaymentTypeSchemaPaymentTypeEnum,
    deliveryType: DeliveryTypeToPaymentTypeSchemaDeliveryTypeEnum,
    checkCreditLimit: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    requireCreditLimit: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const TaxSchema = BaseEntitySchema.extend({
    code: z.string(),
    description: z.string(),
    items: z.array(z.object({ id: z.number() }))
});
export const TaxItemSchema = BaseEntitySchema.extend({
    taxRegion: TaxItemSchemaTaxRegionEnum,
    value: z.number(),
    itemAccountingCode: z.string(),
    issuedInvoiceAccountingCode: z.string(),
    receivedInvoiceAccountingCode: z.string(),
    tax: z.object({ id: z.number() }).nullish()
});
export const EdiFtpAccountSchema = BaseEntitySchema.extend({
    number: z.number(),
    username: z.string()
});
export const PriceTypeSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string(),
    isSystem: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const FifoPriceSnapshotSchema = z.object({
    id: z.number().nullish(),
    item: z.object({ id: z.number() }),
    timestamp: z.coerce.date(),
    data: z.any(),
    inboundDocumentLine: z.object({ id: z.number() }).nullish(),
    outboundDocumentLine: z.object({ id: z.number() }).nullish()
});
export const CarrierCommunicationItemSchema = z.object({
    id: z.number(),
    carrier: z.object({ id: z.number() }),
    request: z.any().nullish(),
    response: z.any().nullish(),
    timestamp: z.coerce.date(),
    statusCode: z.number().nullish()
});
export const DocumentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    code: z.string(),
    agendaType: DocumentTypeSchemaAgendaTypeEnum,
    documentSerie: z.object({ id: z.number() }),
    currency: DocumentTypeSchemaCurrencyEnum.nullish(),
    exchanRateType: DocumentTypeSchemaExchanRateTypeEnum.nullish(),
    clearingPrescription: z.object({ id: z.number() }).nullish(),
    documentTemplate: z.object({ id: z.number() }).nullish(),
    defaultPaymentType: DocumentTypeSchemaDefaultPaymentTypeEnum.nullish(),
    allowSetDocumentNumber: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const InboundDeliveryOrderDocumentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    documentSerie: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() })
});
export const OutboundDeliveryOrderDocumentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    documentSerie: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }),
    createWarehouseOrderImmediately: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    allowCumulativeOutbound: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    packingType: OutboundDeliveryOrderDocumentTypeSchemaPackingTypeEnum.nullish(),
    packingLines: z.array(z.object({ id: z.number() })),
    checkingType: OutboundDeliveryOrderDocumentTypeSchemaCheckingTypeEnum.nullish(),
    needDeliveryLoading: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    shipmentType: OutboundDeliveryOrderDocumentTypeSchemaShipmentTypeEnum.nullish(),
    defaultDestinationLocation: z.object({ id: z.number() }).nullish()
});
export const InboundDeliveryRequestDocumentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    documentSerie: z.object({ id: z.number() }),
    outboundDeliveryOrderDocumentTypes: z.array(z.object({ id: z.number() })),
    outboundDeliveryOrderDocumentType: z.object({ id: z.number() }),
    inboundDeliveryOrderDocumentTypes: z.array(z.object({ id: z.number() }))
});
export const OutboundDeliveryRequestDocumentTypeSchema = DocumentTypeSchema.extend({
    agendaType: OutboundDeliveryRequestDocumentTypeSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'OutboundDeliveryRequest' : v)),
    outboundDeliveryOrderDocumentTypes: z.array(z.object({ id: z.number() })),
    outboundDeliveryOrderDocumentType: z.object({ id: z.number() }),
    inboundDeliveryOrderDocumentTypes: z.array(z.object({ id: z.number() })),
    inboundDeliveryOrderDocumentType: z.object({ id: z.number() }).nullish()
});
export const OutboundDocumentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    code: z.string(),
    agendaType: OutboundDocumentTypeSchemaAgendaTypeEnum,
    documentSerie: z.object({ id: z.number() }),
    currency: OutboundDocumentTypeSchemaCurrencyEnum.nullish(),
    exchanRateType: OutboundDocumentTypeSchemaExchanRateTypeEnum.nullish(),
    clearingPrescription: z.object({ id: z.number() }).nullish(),
    documentTemplate: z.object({ id: z.number() }).nullish(),
    defaultPaymentType: OutboundDocumentTypeSchemaDefaultPaymentTypeEnum.nullish(),
    allowSetDocumentNumber: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    generateInvoice: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    autoValuation: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    confirmationStrategy: OutboundDocumentTypeSchemaConfirmationStrategyEnum,
    completationStrategy: OutboundDocumentTypeSchemaCompletationStrategyEnum,
    cashIssuedInvoiceDocumentType: z.object({ id: z.number() }).nullish(),
    bankTransferIssuedInvoiceDocumentType: z.object({ id: z.number() }).nullish(),
    cashOnDeliveryIssuedInvoiceDocumentType: z.object({ id: z.number() }).nullish(),
    cardIssuedInvoiceDocumentType: z.object({ id: z.number() }).nullish(),
    issuedInvoiceDocumentType: z.object({ id: z.number() }).nullish(),
    outboundDeliveryRequestDocumentType: z.object({ id: z.number() }),
    personalOutboundDeliveryRequestDocumentType: z.object({ id: z.number() }).nullish(),
    deliveryOutboundDeliveryRequestDocumentType: z.object({ id: z.number() }).nullish(),
    carrierOutboundDeliveryRequestDocumentType: z.object({ id: z.number() }).nullish(),
    allowedShipmentTypes: z.array(z.object({ id: z.number() }))
});
export const InboundDocumentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    code: z.string(),
    agendaType: InboundDocumentTypeSchemaAgendaTypeEnum,
    documentSerie: z.object({ id: z.number() }),
    inboundDeliveryRequestDocumentType: z.object({ id: z.number() }).nullish(),
    currency: InboundDocumentTypeSchemaCurrencyEnum.nullish(),
    exchanRateType: InboundDocumentTypeSchemaExchanRateTypeEnum.nullish(),
    clearingPrescription: z.object({ id: z.number() }).nullish(),
    documentTemplate: z.object({ id: z.number() }).nullish(),
    defaultPaymentType: InboundDocumentTypeSchemaDefaultPaymentTypeEnum.nullish(),
    allowSetDocumentNumber: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const IssuedInvoiceDocumentTypeSchema = DocumentTypeSchema.extend({
    agendaType: IssuedInvoiceDocumentTypeSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'IssuedInvoice' : v)),
    bankAccount: z.object({ id: z.number() }).nullish(),
    isSelfBilling: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    penaltiesPercentage: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v))
});
export const ReceivedInvoiceDocumentTypeSchema = DocumentTypeSchema.extend({
    agendaType: ReceivedInvoiceDocumentTypeSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'ReceivedInvoice' : v))
});
export const InboundDocumentLineSchema = DocumentLineSchema.extend({
    quantityOutbound: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityWmsCompleted: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityInvoiced: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityUninvoiced: z.number().nullish(),
    weightedAverageUnitCost: z.number().nullish(),
    weightedAverageUnitCostBonus: z.number().nullish(),
    inboundDocument: z.object({ id: z.number() }).nullish(),
    supplierPricelist: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    inboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    purchaseOrderLine: z.object({ id: z.number() }).nullish(),
    receivedInvoiceLines: z.array(z.object({ id: z.number() })).nullish(),
    accountingCreditSide: z.string().nullish(),
    accountingDebitSide: z.string().nullish(),
    saleOrderLineToCover: z.object({ id: z.number() }).nullish()
});
export const OutboundDocumentLineSchema = BaseEntitySchema.extend({
    position: z.number().nullish(),
    code: z.string().nullish(),
    foreignCode: z.string().nullish(),
    text: z.string().nullish(),
    quantity: z.number(),
    quantityWmsCompleted: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityDispatched: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityOutbound: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    recalculatePrices: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    lineItemType: OutboundDocumentLineSchemaLineItemTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'Item' : v)),
    item: z.object({ id: z.number() }).nullish(),
    note: z.string().nullish(),
    totalWeightNetto: z.number().nullish(),
    totalRecycleFee: z.number().nullish(),
    fifoUnitCost: z.number().nullish(),
    weightedAverageUnitCost: z.number().nullish(),
    weightedAverageUnitCostBonus: z.number().nullish(),
    outboundDocument: z.object({ id: z.number() }).nullish(),
    saleOrderLine: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    inboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    vat: z.number().nullish(),
    domesticPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    price: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    bonusPriceAmount: z.number().nullish(),
    domesticBonusPriceAmount: z.number().nullish(),
    recipientPriceAmount: z.number().nullish(),
    recipientTotalPriceAmount: z.number().nullish(),
    accountingCreditSide: z.string().nullish(),
    accountingDebitSide: z.string().nullish()
});
export const SalesChannelSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    enabled: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    group: z.object({ id: z.number() }),
    documentKindMask: z.string().nullish(),
    userSelectable: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    parent: z.object({ id: z.number() }).nullish(),
    warehouse: z.object({ id: z.number() }).nullish(),
    strictCarrier: z.object({ id: z.number() }).nullish(),
    limitToCarriers: z.array(z.object({ id: z.number() })),
    carrierSelectionStrategy: SalesChannelSchemaCarrierSelectionStrategyEnum.nullish().transform((v) => (v === null || v === undefined ? 'Cheapest' : v)),
    children: z.array(z.object({ id: z.number() })),
    saleOrderDocumentType: z.object({ id: z.number() }),
    party: z.object({ id: z.number() }).nullish(),
    itemCollection: z.object({ id: z.number() }).nullish(),
    brokerMode: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    exportPricelists: z.array(z.object({ id: z.number() })),
    pricelistItemsOnly: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isDropshipping: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    deliveryPricelist: z.object({ id: z.number() }).nullish(),
    addDeliveryPricelistLine: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    addHalfPackagePenalty: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    buyerDeliveryPricelist: z.object({ id: z.number() }).nullish(),
    usePricelistPrices: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    defaultSalesman: z.object({ id: z.number() }).nullish(),
    defaultCreditLimit: z.number().nullish(),
    defaultApprovedState: SalesChannelSchemaDefaultApprovedStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Pending' : v)),
    defaultLanguage: SalesChannelSchemaDefaultLanguageEnum.nullish().transform((v) => (v === null || v === undefined ? 'CZ' : v)),
    exchangeRateType: SalesChannelSchemaExchangeRateTypeEnum.nullish(),
    ediHandler: SalesChannelSchemaEdiHandlerEnum,
    ediHandlerOptions: z.any().nullish(),
    ediFtpAccount: z.object({ id: z.number() }).nullish(),
    testMode: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    testModeNote: z.string().nullish(),
    scheduledTask: z.object({ id: z.number() }).nullish(),
    country: SalesChannelSchemaCountryEnum
});
export const SalesChannelGroupSchema = BaseEntitySchema.extend({
    code: z.string(),
    name: z.string().nullish()
});
export const OutboundDeliveryDocumentTypeSchema = DocumentTypeSchema.extend({
    agendaType: OutboundDeliveryDocumentTypeSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'OutboundDelivery' : v))
});
export const InboundDeliveryDocumentTypeSchema = DocumentTypeSchema.extend({
    agendaType: InboundDeliveryDocumentTypeSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'InboundDelivery' : v))
});
export const ItemCollectionSchema = BaseEntitySchema.extend({
    name: z.string(),
    itemFilter: z.any().nullish(),
    parametersFilter: z.any().nullish()
});
export const SaleOrderDocumentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    code: z.string(),
    documentSerie: z.object({ id: z.number() }),
    currency: SaleOrderDocumentTypeSchemaCurrencyEnum.nullish(),
    exchanRateType: SaleOrderDocumentTypeSchemaExchanRateTypeEnum.nullish(),
    clearingPrescription: z.object({ id: z.number() }).nullish(),
    documentTemplate: z.object({ id: z.number() }).nullish(),
    defaultPaymentType: SaleOrderDocumentTypeSchemaDefaultPaymentTypeEnum.nullish(),
    allowSetDocumentNumber: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    agendaType: SaleOrderDocumentTypeSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'SaleOrder' : v)),
    cashOutboundDocumentType: z.object({ id: z.number() }).nullish(),
    bankTransferOutboundDocumentType: z.object({ id: z.number() }).nullish(),
    cashOnDeliveryOutboundDocumentType: z.object({ id: z.number() }).nullish(),
    outboundDocumentType: z.object({ id: z.number() }),
    deliveryFeeCalculator: z.object({ id: z.number() }).nullish(),
    notificationNewOrderAllReserved: z.object({ id: z.number() }).nullish(),
    notificationNewOrderPartiallyReserved: z.object({ id: z.number() }).nullish(),
    notificationNewOrderNoneReserved: z.object({ id: z.number() }).nullish(),
    notificationOrderDispatched: z.object({ id: z.number() }).nullish(),
    notificationOrderCanceled: z.object({ id: z.number() }).nullish()
});
export const PurchaseOrderDocumentTypeSchema = DocumentTypeSchema.extend({
    agendaType: PurchaseOrderDocumentTypeSchemaAgendaTypeEnum.nullish().transform((v) => (v === null || v === undefined ? 'PurchaseOrder' : v)),
    inboundDocumentType: z.object({ id: z.number() }).nullish()
});
export const InboundDocumentSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    documentNumber: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    issuedDate: z.coerce.date().nullish(),
    receivedAt: z.coerce.date().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    foreignInvoiceNumber: z.string().nullish(),
    documentType: z.object({ id: z.number() }),
    state: InboundDocumentSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    supplier: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }).nullish(),
    archived: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    taxRegion: InboundDocumentSchemaTaxRegionEnum,
    calculateTax: z.boolean().nullish(),
    currency: InboundDocumentSchemaCurrencyEnum.nullish(),
    deliveryType: InboundDocumentSchemaDeliveryTypeEnum.nullish(),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    exchangeRate: z.number().nullish(),
    note: z.string().nullish(),
    paymentType: InboundDocumentSchemaPaymentTypeEnum.nullish(),
    correctionOriginalDocument: z.object({ id: z.number() }).nullish(),
    documentIsValued: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    lines: z.array(z.object({ id: z.number() })),
    inboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    outboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    synchronizationItems: z.array(z.object({ id: z.number() })).nullish(),
    wmsInboundCompleted: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    wmsOutboundCompleted: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const OutboundDocumentSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    documentNumber: z.string().nullish(),
    documentKindMask: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    buyerOrderNumber: z.string().nullish(),
    foreignInvoiceNumber: z.string().nullish(),
    dispatchAdviceNumber: z.string().nullish(),
    issuedDate: z.coerce.date().nullish(),
    buyer: z.object({ id: z.number() }),
    contractor: z.object({ id: z.number() }),
    contractorSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    currency: OutboundDocumentSchemaCurrencyEnum,
    buyerSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    recipient: z.object({ id: z.number() }).nullish(),
    recipientSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    archived: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    taxRegion: OutboundDocumentSchemaTaxRegionEnum,
    requestDate: z.coerce.date().nullish(),
    dispatchedAt: z.coerce.date().nullish(),
    deliveryPricelist: z.object({ id: z.number() }).nullish(),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    exchangeRate: z.number().nullish(),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    outsourcingCost: z.number().nullish(),
    recipientTotalPrice: z.number().nullish(),
    isDropshipping: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    note: z.string().nullish(),
    inventoryLiquidationReason: z.string().nullish(),
    buyerNote: z.string().nullish(),
    recipientNote: z.string().nullish(),
    totalWeightNetto: z.number().nullish(),
    totalRecycleFee: z.number().nullish(),
    priceRounding: z.number().nullish(),
    documentType: z.object({ id: z.number() }),
    printed: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    deliveryType: OutboundDocumentSchemaDeliveryTypeEnum,
    documentIsValued: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    paymentType: OutboundDocumentSchemaPaymentTypeEnum,
    carrier: z.object({ id: z.number() }).nullish(),
    correctionOriginalDocument: z.object({ id: z.number() }).nullish(),
    excludeFromStatistics: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    isCorrectionDocument: z.boolean().nullish(),
    state: OutboundDocumentSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    variableSymbol: z.string().nullish(),
    shipmentState: OutboundDocumentSchemaShipmentStateEnum.nullish(),
    shipmentDocumentChecked: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    warehouse: z.object({ id: z.number() }),
    shipmentTurn: z.number().nullish(),
    lines: z.array(z.object({ id: z.number() })),
    totalQuantity: z.number().nullish(),
    calculateTax: z.boolean().nullish(),
    outboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    inboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    saleOrder: z.object({ id: z.number() }).nullish(),
    invoice: z.object({ id: z.number() }).nullish(),
    shipmentRoute: z.object({ id: z.number() }).nullish(),
    loadShipmentStop: z.object({ id: z.number() }).nullish(),
    activeUnloadShipmentStop: z.object({ id: z.number() }).nullish(),
    activeLoadShipmentStop: z.object({ id: z.number() }).nullish(),
    shipmentStopAssignments: z.array(z.object({ id: z.number() })),
    synchronizationItems: z.array(z.object({ id: z.number() })),
    deliveryShipmentTimeWindows: z.any().nullish(),
    wmsInboundCompleted: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    wmsOutboundCompleted: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    lastStateBeforeCancel: OutboundDocumentSchemaLastStateBeforeCancelEnum.nullish()
});
export const InventoryItemDailySchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    item: z.object({ id: z.number() }),
    validFrom: z.coerce.date(),
    validTo: z.coerce.date().nullish(),
    quantityStored: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityIn: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityOut: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityBalance: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v))
});
export const TemporaryFileSchema = BaseEntitySchema.extend({
    path: z.string(),
    originalName: z.string(),
    mimetype: z.string().nullish(),
    expireAt: z.coerce.date()
});
export const NestJobSchema = z.object({
    id: z.string().nullish(),
    name: z.string().nullish(),
    state: NestJobSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    data: z.any().nullish(),
    priority: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    retryLimit: z.number().nullish(),
    retryCount: z.number().nullish(),
    uniqueKey: z.string().nullish(),
    onceAtTimeKey: z.string().nullish(),
    timeoutSeconds: z.number().nullish().transform((v) => (v === null || v === undefined ? 900 : v)),
    createdAt: z.coerce.date().nullish(),
    startAfter: z.coerce.date().nullish(),
    startedAt: z.coerce.date().nullish(),
    completedAt: z.coerce.date().nullish(),
    consumer: z.string().nullish(),
    progress: z.any().nullish(),
    output: z.any().nullish()
});
export const NotificationSchema = BaseEntitySchema.extend({
    identity: z.object({ id: z.number() }),
    key: z.string(),
    message: z.string(),
    data: z.any().nullish(),
    readAt: z.coerce.date().nullish()
});
export const BatchInvoiceRuleSchema = BaseEntitySchema.extend({
    name: z.string(),
    scheduledTask: z.object({ id: z.number() }).nullish(),
    includeCorrectionDocuments: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const ItemCategorySchema = BaseEntitySchema.extend({
    code: z.string(),
    name: z.string().nullish()
});
export const ItemCategoryGroupSchema = BaseEntitySchema.extend({
    name: z.string(),
    itemCategories: z.array(z.object({ id: z.number() }))
});
export const DeliveryPricelistSchema = BaseEntitySchema.extend({
    name: z.string().nullish(),
    code: z.string(),
    isDefault: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    items: z.array(z.object({ id: z.number() })),
    halfPackagePenalty: z.any().nullish()
});
export const DeliveryPricelistItemSchema = BaseEntitySchema.extend({
    pricelist: z.object({ id: z.number() }),
    deliveryType: DeliveryPricelistItemSchemaDeliveryTypeEnum.nullish(),
    paymentType: DeliveryPricelistItemSchemaPaymentTypeEnum.nullish(),
    country: DeliveryPricelistItemSchemaCountryEnum,
    itemCategoryGroup: z.object({ id: z.number() }).nullish(),
    packageType: z.object({ id: z.number() }).nullish(),
    price: z.number(),
    carrierPrice: z.number(),
    buyerPrice: z.number(),
    pricePenalty: z.number(),
    currency: DeliveryPricelistItemSchemaCurrencyEnum,
    placeholderItem: z.object({ id: z.number() }).nullish(),
    position: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v))
});
export const SynchronizationItemSchema = z.object({
    id: z.number().nullish(),
    applicationName: z.string(),
    type: z.string(),
    state: SynchronizationItemSchemaStateEnum,
    item: z.object({ id: z.number() }).nullish(),
    warehouse: z.object({ id: z.number() }).nullish(),
    invoice: z.object({ id: z.number() }).nullish(),
    outboundDocument: z.object({ id: z.number() }).nullish(),
    inboundDocument: z.object({ id: z.number() }).nullish(),
    party: z.object({ id: z.number() }).nullish(),
    payment: z.object({ id: z.number() }).nullish(),
    hasOutboundDocumentIssuedInvoice: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    hasInboundDocumentReceivedInvoice: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    hasOutboundDocumentCorrection: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    request: z.any().nullish(),
    response: z.any().nullish(),
    foreignId: z.string().nullish(),
    timestamp: z.coerce.date(),
    errorMessage: z.string().nullish()
});
export const PurchaseOrderSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    documentNumber: z.string().nullish(),
    foreignOrderNumber: z.string().nullish(),
    issuedDate: z.coerce.date().nullish(),
    state: PurchaseOrderSchemaStateEnum.nullish().transform((v) => (v === null || v === undefined ? 'Created' : v)),
    buyer: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }).nullish(),
    taxRegion: PurchaseOrderSchemaTaxRegionEnum.nullish(),
    calculateTax: z.boolean().nullish(),
    currency: PurchaseOrderSchemaCurrencyEnum.nullish(),
    deliveryType: PurchaseOrderSchemaDeliveryTypeEnum.nullish(),
    domesticTotalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    totalPrice: z.object({
        netto: z.number().nullish(),
        brutto: z.number().nullish(),
        vatAmount: z.number().nullish(),
        setWithVat: z.boolean().nullish()
    }),
    exchangeRate: z.number().nullish(),
    note: z.string().nullish(),
    paymentType: PurchaseOrderSchemaPaymentTypeEnum.nullish(),
    buyerSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    contractorSnapshot: z.object({
        code: z.string().nullish(),
        name: z.string().nullish(),
        name2: z.string().nullish(),
        street: z.string().nullish(),
        city: z.string().nullish(),
        zipCode: z.string().nullish(),
        country: PartySnapshotSchemaCountryEnum.nullish(),
        currency: PartySnapshotSchemaCurrencyEnum.nullish(),
        gps: z.any().nullish(),
        phone: z.string().nullish(),
        email: z.string().nullish(),
        vatNumber: z.string().nullish(),
        idNumber: z.string().nullish()
    }),
    archived: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    contractor: z.object({ id: z.number() }),
    documentType: z.object({ id: z.number() }),
    supplierPricelist: z.object({ id: z.number() }).nullish(),
    lines: z.array(z.object({ id: z.number() }))
});
export const PurchaseOrderLineSchema = DocumentLineSchema.extend({
    quantityInbound: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityConfirmed: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityConfirmRemaining: z.number().nullish(),
    quantityInboundRemaining: z.number().nullish(),
    bonusPriceAmount: z.number().nullish(),
    supplierPricelist: z.object({ id: z.number() }).nullish(),
    saleOrderLineToCover: z.object({ id: z.number() }).nullish(),
    inboundDocumentLines: z.array(z.object({ id: z.number() })).nullish(),
    purchaseOrder: z.object({ id: z.number() })
});
export const PackingLineConfigurationDockSchema = BaseEntitySchema.extend({
    deliveryType: PackingLineConfigurationDockSchemaDeliveryTypeEnum,
    dock: z.number(),
    position: z.number().nullish().transform((v) => (v === null || v === undefined ? 1 : v)),
    print: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    pack: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    carrier: z.object({ id: z.number() }).nullish(),
    country: PackingLineConfigurationDockSchemaCountryEnum.nullish(),
    machine: z.object({ id: z.number() }).nullish(),
    storageLocation: z.object({ id: z.number() })
});
export const PartySalesmanAssignSchema = z.object({
    id: z.number().nullish(),
    assignedAt: z.coerce.date(),
    party: z.object({ id: z.number() }),
    salesman: z.object({ id: z.number() }).nullish()
});
export const PartyTagSchema = z.object({
    id: z.number().nullish(),
    name: z.string().nullish(),
    party: z.object({ id: z.number() }).nullish()
});
export const SaleOrderRuleSchema = BaseEntitySchema.extend({
    name: z.string(),
    isActive: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    query: z.any()
});
export const TerminalConfigurationSchema = BaseEntitySchema.extend({
    name: z.string(),
    menuItems: TerminalConfigurationSchemaMenuItemsEnum,
    warehouse: z.object({ id: z.number() }),
    views: z.array(z.object({ id: z.number() }))
});
export const TerminalConfigurationViewSchema = BaseEntitySchema.extend({
    code: TerminalConfigurationViewSchemaCodeEnum,
    definition: z.any(),
    terminalConfiguration: z.object({ id: z.number() }).nullish()
});
export const ClearingPrescriptionSchema = BaseEntitySchema.extend({
    name: z.string(),
    code: z.string().nullish(),
    items: z.array(z.object({ id: z.number() }))
});
export const DocumentLineTemplateSchema = BaseEntitySchema.extend({
    text: z.string(),
    agendaType: DocumentLineTemplateSchemaAgendaTypeEnum,
    code: z.string().nullish(),
    quantity: z.number().nullish(),
    recalculatePrices: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    accountingDebitSide: z.string().nullish(),
    accountingCreditSide: z.string().nullish(),
    tax: z.object({ id: z.number() }).nullish()
});
export const ClearingPrescriptionItemSchema = BaseEntitySchema.extend({
    agendaType: ClearingPrescriptionItemSchemaAgendaTypeEnum,
    debitSide: z.string().nullish(),
    creditSide: z.string().nullish(),
    clearingPrescription: z.object({ id: z.number() })
});
export const SepaOptionsSchema = BaseEntitySchema.extend({
    paymentType: SepaOptionsSchemaPaymentTypeEnum,
    painSchema: z.string(),
    numericSequence: z.object({ id: z.number() }),
    initiatorName: z.string(),
    localInstrument: SepaOptionsSchemaLocalInstrumentEnum,
    creditorName: z.string(),
    creditorIban: z.string(),
    creditorBic: z.string(),
    creditorIdentificator: z.string()
});
export const SepaPaymentSchema = BaseEntitySchema.extend({
    invoice: z.object({ id: z.number() }).nullish(),
    painSchema: z.string(),
    batchIdentificator: z.string(),
    batchCreated: z.coerce.date(),
    initiatorName: z.string(),
    localInstrument: z.string(),
    sequenceType: SepaPaymentSchemaSequenceTypeEnum,
    collectionDate: z.coerce.date(),
    creditorName: z.string(),
    creditorIban: z.string(),
    creditorBic: z.string(),
    creditorIdentificator: z.string(),
    debtorName: z.string(),
    debtorIban: z.string(),
    debtorBic: z.string(),
    mandateReference: z.string(),
    mandateSignatureDate: z.coerce.date(),
    amount: z.number(),
    currency: SepaPaymentSchemaCurrencyEnum,
    remittanceInfo: z.string(),
    endToEndIdentificator: z.string(),
    archived: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const ApplicationRuleSchema = BaseEntitySchema.extend({
    name: z.string(),
    type: ApplicationRuleSchemaTypeEnum,
    entityName: z.string(),
    filterQuery: z.any().nullish(),
    propertyModifications: z.any().nullish(),
    disallow: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const InventoryItemSchema = BaseEntitySchema.extend({
    item: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }).nullish(),
    quantity: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityAvailable: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityUnconfirmed: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityUnvalued: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityReserved: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    quantityOutbound: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v))
});
export const WarehouseDeliveryAreaItemSchema = BaseEntitySchema.extend({
    warehouse: z.object({ id: z.number() }),
    zipCode: z.string()
});
export const ItemReportingSchema = z.object({
    id: z.number().nullish(),
    item: z.object({ id: z.number() }).nullish(),
    sell_d0: z.number().nullish(),
    sell_d7: z.number().nullish(),
    sell_d14: z.number().nullish(),
    sell_d21: z.number().nullish(),
    sell_d60: z.number().nullish(),
    sell_d90: z.number().nullish(),
    sell_d365: z.number().nullish(),
    warehouse1Quantity: z.number().nullish(),
    warehouse2Quantity: z.number().nullish(),
    priceAdpCzk: z.number().nullish()
});
export const UserTrackingRecordSchema = z.object({
    id: z.number().nullish(),
    identity: z.object({ id: z.number() }),
    timestamp: z.coerce.date().nullish(),
    type: z.string().nullish(),
    data: z.any().nullish()
});
export const IdentityTerminalStateSchema = BaseEntitySchema.extend({
    identity: z.object({ id: z.number() }),
    activeOutboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    activeOutboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    activeInboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    activeInboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    activeWavelessPickingDocumentType: z.object({ id: z.number() }).nullish(),
    activeWavelessPickingShipmentRouteLinks: z.array(z.object({ id: z.number() })).nullish(),
    previousWavelessPickingStockItemLocation: z.object({ id: z.number() }).nullish(),
    activeWavelessPickingStockItemLocation: z.object({ id: z.number() }).nullish(),
    activeWavelessPickingStockItemQuantity: z.number().nullish(),
    pickingHandlingUnit: z.object({ id: z.number() }).nullish(),
    hasActiveInWarehouseMove: IdentityTerminalStateSchemaHasActiveInWarehouseMoveEnum.nullish(),
    warehouseProcessBatchItems: z.array(z.object({ id: z.number() })).nullish()
});
export const WarehouseProcessBatchItemSchema = BaseEntitySchema.extend({
    terminalState: z.object({ id: z.number() }).nullish(),
    wavelessOutboundDeliveryOrderLine: z.object({ id: z.number() }).nullish(),
    wavelessQuantityLoaded: z.number()
});
export const WarehouseRelationSchema = BaseEntitySchema.extend({
    items: z.array(z.object({ id: z.number() })),
    warehouse: z.object({ id: z.number() }),
    type: WarehouseRelationSchemaTypeEnum,
    outboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    inboundDeliveryOrder: z.object({ id: z.number() }).nullish(),
    shipmentRoute: z.object({ id: z.number() }).nullish(),
    isCompleted: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const WarehouseRelationItemSchema = BaseEntitySchema.extend({
    stockItem: z.object({ id: z.number() }).nullish(),
    handlingUnit: z.object({ id: z.number() }).nullish(),
    quantity: z.number(),
    batch: z.number().nullish(),
    originCountry: WarehouseRelationItemSchemaOriginCountryEnum.nullish(),
    sourceWarehouseLocation: z.object({ id: z.number() }).nullish(),
    destinationWarehouseLocation: z.object({ id: z.number() }).nullish(),
    warehouseRelation: z.object({ id: z.number() })
});
export const CustomEntityViewSchema = BaseEntitySchema.extend({
    label: z.string(),
    defaultName: z.string().nullish(),
    scope: z.string(),
    entityName: z.string(),
    definition: z.any(),
    position: z.number(),
    isFavorite: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const InboundQueueSchema = BaseEntitySchema.extend({
    documentType: z.object({ id: z.number() }),
    name: z.string(),
    warehouse: z.object({ id: z.number() }),
    rule: z.any().nullish(),
    gridConfiguration: z.any().nullish(),
    isFolder: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    parent: z.object({ id: z.number() }).nullish()
});
export const WarehouseCarrierSchema = BaseEntitySchema.extend({
    warehouse: z.object({ id: z.number() }),
    carrier: z.object({ id: z.number() }),
    packageCountDayLimit: z.number().nullish()
});
export const ItemCheapestDeliverySchema = BaseEntitySchema.extend({
    item: z.object({ id: z.number() }),
    deliveryPricelist: z.object({ id: z.number() }),
    deliveryPricelistItem: z.object({ id: z.number() }),
    cost: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    country: ItemCheapestDeliverySchemaCountryEnum,
    quantityInPackage: z.number(),
    packageType: z.object({ id: z.number() })
});
export const ConsignmentNoteSchema = BaseEntitySchema.extend({
    warehouse: z.object({ id: z.number() }),
    carrier: z.object({ id: z.number() }),
    containerNumber: z.string().nullish(),
    issuedDate: z.coerce.date().nullish(),
    isCompleted: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    completedAt: z.coerce.date().nullish(),
    lines: z.array(z.object({ id: z.number() }))
});
export const ConsignmentNoteLineSchema = BaseEntitySchema.extend({
    packageUnit: z.object({ id: z.number() }),
    consignmentNote: z.object({ id: z.number() })
});
export const SupplyChannelSchema = BaseEntitySchema.extend({
    name: z.string(),
    enabled: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    organization: z.object({ id: z.number() }),
    contractor: z.object({ id: z.number() }),
    ediHandler: z.string(),
    ediHandlerOptions: z.any().nullish()
});
export const EltmaItemSchema = BaseEntitySchema.extend({
    type: z.string().nullish(),
    item: z.object({ id: z.number() }).nullish(),
    quantity: z.number().nullish(),
    remaining: z.number().nullish(),
    issuedAt: z.coerce.date().nullish(),
    inboundDocumentLine: z.object({ id: z.number() }).nullish(),
    outboundDocumentLine: z.object({ id: z.number() }).nullish(),
    inoutboundDocumentLine: z.object({ id: z.number() }).nullish(),
    refunds: z.array(z.object({ id: z.number() }))
});
export const EltmaItemRefundSchema = BaseEntitySchema.extend({
    quantity: z.number().nullish(),
    inboundDocumentLine: z.object({ id: z.number() }).nullish(),
    eltmaItem: z.object({ id: z.number() }).nullish(),
    isImported: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const CpostLocationSchema = z.object({
    id: z.number(),
    locationKey: z.string(),
    locationData: z.any(),
    cpostId: z.number()
});
export const NestJobSubscriptionSchema = z.object({
    eventName: z.string(),
    jobName: z.string()
});
export const ShipmentAreaSchema = BaseEntitySchema.extend({
    name: z.string(),
    zips: z.array(z.object({ id: z.number() })),
    rules: z.array(z.object({ id: z.number() })),
    shipmentRouteTypes: z.array(z.object({ id: z.number() }))
});
export const ShipmentAreaZipSchema = BaseEntitySchema.extend({
    zip: z.string(),
    shipmentArea: z.object({ id: z.number() })
});
export const ShipmentRouteLinkSchema = BaseEntitySchema.extend({
    name: z.string(),
    zips: z.array(z.object({ id: z.number() })),
    shipmentVehicles: z.array(z.object({ id: z.number() })),
    color: z.string().nullish()
});
export const ShipmentRouteLinkZipSchema = BaseEntitySchema.extend({
    zip: z.string(),
    shipmentRouteLink: z.object({ id: z.number() })
});
export const OutboundDocumentDeliveryDateRuleSchema = BaseEntitySchema.extend({
    warehouse: z.object({ id: z.number() }),
    dayDeadlineTime: z.number(),
    addDays: z.number(),
    addSeconds: z.number(),
    shipmentArea: z.object({ id: z.number() }).nullish()
});
export const AddressToGpsSchema = BaseEntitySchema.extend({
    addressSlug: z.string(),
    gps: z.any().nullish(),
    status: z.string()
});
export const NumericSequenceItemSchema = BaseEntitySchema.extend({
    year: z.number().nullish(),
    code: z.string().nullish(),
    currentValue: z.number(),
    numericSequence: z.object({ id: z.number() })
});
export const BankAccountSnapshotSchema = z.object({
    code: z.string().nullish(),
    accountName: z.string().nullish(),
    accountNumber: z.string().nullish(),
    bankName: z.string().nullish(),
    bankCode: z.string().nullish(),
    iban: z.string().nullish(),
    bic: z.string().nullish()
});
export const PriceAmountSchema = z.object({
    netto: z.number().nullish(),
    brutto: z.number().nullish(),
    vatAmount: z.number().nullish(),
    setWithVat: z.boolean().nullish()
});
export const PartySnapshotSchema = z.object({
    code: z.string().nullish(),
    name: z.string().nullish(),
    name2: z.string().nullish(),
    street: z.string().nullish(),
    city: z.string().nullish(),
    zipCode: z.string().nullish(),
    country: PartySnapshotSchemaCountryEnum.nullish(),
    currency: PartySnapshotSchemaCurrencyEnum.nullish(),
    gps: z.any().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    vatNumber: z.string().nullish(),
    idNumber: z.string().nullish()
});
export const ShipmentVehicleShipmentTypeSettingSchema = BaseEntitySchema.extend({
    shipmentType: z.object({ id: z.number() }),
    shipmentVehicle: z.object({ id: z.number() }),
    start: z.object({ id: z.number() }).nullish(),
    end: z.object({ id: z.number() }).nullish(),
    costPerRouteFixed: z.number().nullish(),
    costPerRoutePerHour: z.number().nullish(),
    costPerRoutePerKm: z.number().nullish(),
    maxDistanceKilometers: z.number().nullish(),
    maxTravelTimeMinutes: z.number().nullish(),
    maxStops: z.number().nullish(),
    speedFactor: z.number().nullish(),
    disableSoftLimits: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const GpsSchema = z.object({
    lat: z.number().nullish(),
    lng: z.number().nullish()
});
export const ShipmentVehicleTrackingSchema = BaseEntitySchema.extend({
    vehicle: z.object({ id: z.number() }),
    location: z.string(),
    lat: z.number(),
    lng: z.number(),
    odometer: z.number(),
    velocity: z.number(),
    movementStatus: z.string()
});
export const DeliveryPlanSchema = BaseEntitySchema.extend({
    id: z.number(),
    saleOrderId: z.number().nullish(),
    foreignOrderNumber: z.string().nullish(),
    data: z.any().nullish(),
    result: z.string().nullish()
});
export const UpsInvoiceItemSchema = z.object({
    id: z.number(),
    carrier: z.string(),
    month: z.number(),
    year: z.number(),
    consignmentNumber: z.string().nullish(),
    trackingNumber: z.string(),
    reference1: z.string().nullish(),
    fuelSurcharge: z.number().nullish(),
    fuelSurchargeText: z.string().nullish(),
    largePackageSurcharge: z.number().nullish(),
    largePackageSurchargeText: z.string().nullish(),
    actualWeight: z.number().nullish(),
    actualWeightText: z.string().nullish(),
    billedWeight: z.number().nullish(),
    billedWeightText: z.string().nullish(),
    basePrice: z.number().nullish(),
    surchargeTotal: z.number().nullish(),
    surchargeTotalText: z.string().nullish(),
    netTotal: z.number().nullish(),
    toll: z.number().nullish(),
    creditCardFee: z.number().nullish(),
    netTotalText: z.string().nullish(),
    invoiceCurrency: z.string().nullish()
});
export const DepositSchema = BaseEntitySchema.extend({
    documentNumber: z.string(),
    customerDocumentNumber: z.string().nullish(),
    palette: z.object({ id: z.number() }).nullish(),
    branchOffice: z.object({ id: z.number() }),
    state: DepositSchemaStateEnum,
    customer: z.object({ id: z.number() }).nullish(),
    season: DepositSchemaSeasonEnum,
    sku: z.object({ id: z.number() }).nullish(),
    client: z.object({ id: z.number() }).nullish(),
    endCustomerVehicle: z.object({ id: z.number() }).nullish(),
    endCustomerReservationTireChange: z.object({ id: z.number() }).nullish(),
    storedAt: z.coerce.date().nullish(),
    removedAt: z.coerce.date().nullish(),
    outboundDocument: z.object({ id: z.number() }).nullish(),
    inboundDate: z.coerce.date().nullish(),
    unloadAt: z.coerce.date().nullish(),
    foreignDocumentNumber: z.string().nullish(),
    items: z.array(z.object({ id: z.number() }))
});
export const DepositItemSchema = BaseEntitySchema.extend({
    name: z.string(),
    note: z.string().nullish(),
    depth: z.number(),
    tireWidth: z.number().nullish(),
    vehiclePosition: z.string(),
    wheelType: z.string().nullish(),
    disposed: z.boolean(),
    positionOrder: z.number(),
    deposit: z.object({ id: z.number() })
});
export const DeliveryReturnSchema = BaseEntitySchema.extend({
    invoice: z.object({ id: z.number() }),
    storageLocation: z.object({ id: z.number() }),
    stockedAt: z.coerce.date(),
    writtenOffAt: z.coerce.date().nullish()
});
export const ReturnSchema = BaseEntitySchema.extend({
    saleOrderId: z.number(),
    buyer: z.object({ id: z.number() }),
    lines: z.array(z.object({ id: z.number() }))
});
export const ReturnLineSchema = BaseEntitySchema.extend({
    item: z.object({ id: z.number() }),
    quantity: z.number(),
    price: z.number(),
    totalPrice: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    return: z.object({ id: z.number() })
});
export const CartLineSchema = z.object({
    id: z.number(),
    item: z.object({ id: z.number() }),
    quantity: z.number(),
    priceNetto: z.number(),
    totalPriceNetto: z.number(),
    totalPriceBrutto: z.number(),
    owner: z.object({ id: z.number() }),
    endCustomerAssignedAt: z.coerce.date(),
    endCustomer: z.object({ id: z.number() }),
    endCustomerVehicle: z.object({ id: z.number() }),
    installationDate: z.coerce.date(),
    deliveryDate: z.coerce.date()
});
export const EndCustomerSchema = z.object({
    id: z.number(),
    name: z.string(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    party: z.object({ id: z.number() }).nullish(),
    vehicles: z.array(z.object({ id: z.number() }))
});
export const EndCustomerVehicleSchema = z.object({
    id: z.number(),
    name: z.string(),
    licensePlate: z.string().nullish(),
    vin: z.string().nullish(),
    lastUsedTireDimensions: z.any().nullish(),
    endCustomer: z.object({ id: z.number() })
});
export const EndCustomerReservationSchema = z.object({
    id: z.number(),
    owner: z.object({ id: z.number() }),
    reservationDate: z.coerce.date(),
    endCustomer: z.object({ id: z.number() }).nullish(),
    endCustomerVehicle: z.object({ id: z.number() }).nullish(),
    deposit: z.object({ id: z.number() }).nullish(),
    reservationType: EndCustomerReservationSchemaReservationTypeEnum,
    status: EndCustomerReservationSchemaStatusEnum,
    duration: z.number().nullish(),
    allDay: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    createdAt: z.coerce.date()
});
export const PartyIdentitySchema = z.object({
    party: z.object({ id: z.number() }),
    identity: z.object({ id: z.number() }),
    isDefault: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v))
});
export const PartyDepositSettingsSchema = BaseEntitySchema.extend({
    party: z.object({ id: z.number() }),
    warehouse: z.object({ id: z.number() }),
    outboundDocumentType: z.object({ id: z.number() })
});
export const InboundShipmentSchema = BaseEntitySchema.extend({
    inboundDocument: z.object({ id: z.number() }).nullish(),
    requestDate: z.coerce.date().nullish(),
    lineCode: z.string().nullish(),
    warehouse: z.object({ id: z.number() }),
    state: InboundShipmentSchemaStateEnum,
    shipmentRoute: z.object({ id: z.number() }).nullish(),
    activeUnloadShipmentStop: z.object({ id: z.number() }).nullish(),
    activeLoadShipmentStop: z.object({ id: z.number() }).nullish(),
    shipmentStopAssignments: z.array(z.object({ id: z.number() })),
    inboundShipmentType: z.object({ id: z.number() }),
    shipmentTurn: z.number().nullish(),
    lines: z.array(z.object({ id: z.number() })),
    deliveryShipmentTimeWindow: z.any().nullish(),
    sourceParty: z.object({ id: z.number() }),
    issuedDate: z.coerce.date().nullish(),
    deliveryType: InboundShipmentSchemaDeliveryTypeEnum.nullish()
});
export const InboundShipmentLineSchema = BaseEntitySchema.extend({
    inboundShipment: z.object({ id: z.number() }),
    quantityInbound: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    item: z.object({ id: z.number() }).nullish(),
    text: z.string().nullish()
});
export const InboundShipmentTypeSchema = BaseEntitySchema.extend({
    organization: z.object({ id: z.number() }),
    name: z.string(),
    code: z.string(),
    allowedShipmentTypes: z.array(z.object({ id: z.number() }))
});
export const TireosInvoiceExportSchema = BaseEntitySchema.extend({
    invoice: z.object({ id: z.number() }),
    exportedAt: z.coerce.date()
});
export const TireosPreferencesSchema = BaseEntitySchema.extend({
    key: z.string(),
    preferences: z.any(),
    party: z.object({ id: z.number() })
});
export const OutboundDocumentPackageSimulationSchema = BaseEntitySchema.extend({
    packageSimulation: z.object({ id: z.number() }),
    outboundDocument: z.object({ id: z.number() }),
    description: z.string(),
    status: OutboundDocumentPackageSimulationSchemaStatusEnum,
    message: z.string().nullish(),
    deliveryPricelistItemIds: z.any().nullish(),
    deliveryPricelistItemNames: z.any().nullish(),
    totalCost: z.number(),
    plannerMode: z.string().nullish(),
    packageTypes: z.array(z.object({ id: z.number() }))
});
export const OutboundDocumentPackageSimulationPackageTypeSchema = z.object({
    id: z.number(),
    outboundDocumentPackageSimulation: z.object({ id: z.number() }),
    packageType: z.object({ id: z.number() }),
    weightKg: z.number(),
    volumetricWeightKg: z.number(),
    widthCm: z.number(),
    heightCm: z.number(),
    circumferenceCm: z.number(),
    expectedCost: z.number()
});
export const TaskSchema = z.object({
    id: z.number(),
    name: z.string(),
    priority: TaskSchemaPriorityEnum.nullish().transform((v) => (v === null || v === undefined ? 'Normal' : v)),
    deadline: z.coerce.date().nullish(),
    status: TaskSchemaStatusEnum.nullish().transform((v) => (v === null || v === undefined ? 'Open' : v)),
    assignedIdentity: z.object({ id: z.number() }).nullish(),
    assignedRole: z.object({ id: z.number() }).nullish(),
    records: z.array(z.object({ id: z.number() }))
});
export const TaskRecordSchema = z.object({
    id: z.number(),
    task: z.object({ id: z.number() }),
    author: z.object({ id: z.number() }),
    createdAt: z.coerce.date(),
    type: TaskRecordSchemaTypeEnum,
    text: z.string().nullish(),
    data: z.any().nullish()
});
export const PricemachineWorkspaceSchema = BaseEntitySchema.extend({
    name: z.string(),
    description: z.string().nullish(),
    owner: z.object({ id: z.number() }),
    parentWorkspace: z.object({ id: z.number() }).nullish(),
    isActive: z.boolean().nullish().transform((v) => (v === null || v === undefined ? false : v)),
    deletedAt: z.coerce.date().nullish()
});
export const PricemachineItemPricingSchema = BaseEntitySchema.extend({
    item: z.object({ id: z.number() }),
    minimumPrice: z.number().nullish(),
    basePrice: z.number().nullish(),
    currency: PricemachineItemPricingSchemaCurrencyEnum.nullish().transform((v) => (v === null || v === undefined ? 'CZK' : v))
});
export const PricemachineDataSourceSchema = BaseEntitySchema.extend({
    name: z.string(),
    description: z.string().nullish(),
    adapterType: z.string(),
    configuration: z.any(),
    scheduleExpression: z.string().nullish(),
    lastRunAt: z.coerce.date().nullish(),
    enabled: z.boolean().nullish().transform((v) => (v === null || v === undefined ? true : v)),
    retentionPeriodDays: z.number().nullish().transform((v) => (v === null || v === undefined ? 730 : v)),
    aggregations: z.any().nullish()
});
export const PricemachineDataImportRunSchema = BaseEntitySchema.extend({
    dataSource: z.object({ id: z.number() }),
    startedAt: z.coerce.date(),
    completedAt: z.coerce.date().nullish(),
    status: PricemachineDataImportRunSchemaStatusEnum.nullish().transform((v) => (v === null || v === undefined ? 'running' : v)),
    recordsProcessed: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    recordsInserted: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    recordsUpdated: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    recordsFailed: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    retentionPeriodDays: z.number().nullish(),
    errorMessage: z.string().nullish(),
    metadata: z.any().nullish()
});
export const PricemachineDataTyre24PriceSchema = BaseEntitySchema.extend({
    importRun: z.object({ id: z.number() }),
    time: z.coerce.date(),
    itemCode: z.string(),
    competitorId: z.string(),
    competitorName: z.string().nullish(),
    price: z.number(),
    currency: z.string().nullish().transform((v) => (v === null || v === undefined ? 'CZK' : v)),
    stockQuantity: z.number().nullish(),
    deliveryDays: z.number().nullish(),
    deletedAt: z.coerce.date().nullish(),
    metadata: z.any().nullish()
});
export const PricemachineDataNestSalesSchema = BaseEntitySchema.extend({
    importRun: z.object({ id: z.number() }),
    time: z.coerce.date(),
    item: z.object({ id: z.number() }),
    quantity: z.number(),
    revenue: z.number(),
    currency: z.string().nullish().transform((v) => (v === null || v === undefined ? 'CZK' : v)),
    profitMargin: z.number().nullish(),
    customerType: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    metadata: z.any().nullish()
});
export const PricemachineDataPneub2bStockSchema = BaseEntitySchema.extend({
    importRun: z.object({ id: z.number() }),
    time: z.coerce.date(),
    itemCode: z.string(),
    supplierId: z.string(),
    supplierName: z.string().nullish(),
    stockQuantity: z.number(),
    price: z.number().nullish(),
    currency: z.string().nullish().transform((v) => (v === null || v === undefined ? 'CZK' : v)),
    deliveryDays: z.number().nullish(),
    location: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    metadata: z.any().nullish()
});
export const PricemachineConstantSchema = BaseEntitySchema.extend({
    workspace: z.object({ id: z.number() }).nullish(),
    scope: PricemachineConstantSchemaScopeEnum.nullish().transform((v) => (v === null || v === undefined ? 'workspace' : v)),
    name: z.string(),
    description: z.string().nullish(),
    type: PricemachineConstantSchemaTypeEnum,
    valueType: PricemachineConstantSchemaValueTypeEnum,
    staticValue: z.string().nullish(),
    expression: z.string().nullish(),
    enumValues: z.any().nullish()
});
export const PricemachineCalculationNodeSchema = BaseEntitySchema.extend({
    workspace: z.object({ id: z.number() }),
    pipeline: z.object({ id: z.number() }).nullish(),
    nodeType: PricemachineCalculationNodeSchemaNodeTypeEnum,
    name: z.string(),
    description: z.string().nullish(),
    condition: z.string().nullish(),
    formula: z.string().nullish(),
    order: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    parentNode: z.object({ id: z.number() }).nullish(),
    pricelist: z.object({ id: z.number() }).nullish(),
    positionX: z.number().nullish(),
    positionY: z.number().nullish(),
    metadata: z.any().nullish()
});
export const PricemachineCalculationEdgeSchema = BaseEntitySchema.extend({
    sourceNode: z.object({ id: z.number() }),
    targetNode: z.object({ id: z.number() }),
    label: z.string().nullish()
});
export const PricemachinePipelineSchema = BaseEntitySchema.extend({
    workspace: z.object({ id: z.number() }),
    name: z.string(),
    description: z.string().nullish()
});
export const PricemachinePipelineNodeSchema = BaseEntitySchema.extend({
    pipeline: z.object({ id: z.number() }),
    nodeType: PricemachinePipelineNodeSchemaNodeTypeEnum,
    name: z.string(),
    description: z.string().nullish(),
    condition: z.string().nullish(),
    formula: z.string().nullish(),
    order: z.number().nullish().transform((v) => (v === null || v === undefined ? 0 : v)),
    positionX: z.number().nullish(),
    positionY: z.number().nullish(),
    metadata: z.any().nullish()
});
export const PricemachinePipelineEdgeSchema = BaseEntitySchema.extend({
    pipeline: z.object({ id: z.number() }),
    sourceNode: z.object({ id: z.number() }),
    targetNode: z.object({ id: z.number() }),
    label: z.string().nullish()
});
export const PricemachinePricelistSchema = BaseEntitySchema.extend({
    workspace: z.object({ id: z.number() }),
    name: z.string(),
    description: z.string().nullish(),
    currency: PricemachinePricelistSchemaCurrencyEnum.nullish().transform((v) => (v === null || v === undefined ? 'CZK' : v)),
    outputFormat: PricemachinePricelistSchemaOutputFormatEnum.nullish().transform((v) => (v === null || v === undefined ? 'csv' : v)),
    priceRounding: z.number().nullish()
});
export const PricemachineRepricingProposalSchema = BaseEntitySchema.extend({
    workspace: z.object({ id: z.number() }),
    item: z.object({ id: z.number() }),
    pricelist: z.object({ id: z.number() }),
    oldPrice: z.number().nullish(),
    newPrice: z.number(),
    calculatedAt: z.coerce.date(),
    status: PricemachineRepricingProposalSchemaStatusEnum.nullish().transform((v) => (v === null || v === undefined ? 'pending' : v)),
    processedBy: z.object({ id: z.number() }).nullish(),
    processedAt: z.coerce.date().nullish(),
    reason: z.string().nullish()
});
export const PricemachineCalculationLogSchema = BaseEntitySchema.extend({
    workspace: z.object({ id: z.number() }),
    item: z.object({ id: z.number() }).nullish(),
    node: z.object({ id: z.number() }).nullish(),
    level: PricemachineCalculationLogSchemaLevelEnum.nullish().transform((v) => (v === null || v === undefined ? 'info' : v)),
    message: z.string(),
    correlationId: z.string().nullish(),
    duration: z.number().nullish(),
    metadata: z.any().nullish()
});
export const PricemachineConstantVersionSchema = BaseEntitySchema.extend({
    constant: z.object({ id: z.number() }),
    versionNumber: z.number(),
    snapshot: z.any(),
    comment: z.string().nullish(),
    createdBy: z.object({ id: z.number() })
});
export const PricemachineCalculationTreeVersionSchema = BaseEntitySchema.extend({
    workspace: z.object({ id: z.number() }),
    versionNumber: z.number(),
    nodesSnapshot: z.any(),
    edgesSnapshot: z.any(),
    comment: z.string().nullish(),
    createdBy: z.object({ id: z.number() })
});
export const PricemachinePipelineVersionSchema = BaseEntitySchema.extend({
    pipeline: z.object({ id: z.number() }),
    versionNumber: z.number(),
    nodesSnapshot: z.any(),
    edgesSnapshot: z.any(),
    metadataSnapshot: z.any(),
    comment: z.string().nullish(),
    createdBy: z.object({ id: z.number() })
});
export const PricemachineWorkspacePreferencesSchema = BaseEntitySchema.extend({
    identity: z.object({ id: z.number() }),
    workspace: z.object({ id: z.number() }),
    collapsedNodes: z.any().nullish(),
    dockviewLayout: z.any().nullish()
});
export const EntityIdDtoSchema = z.object({ id: z.number() });
//# sourceMappingURL=index.js.map